export default {
  "nav_signin": "Entrar",
  "nav_account": "Conta",
  "nav_signout": "Sair",
  "hero_title": "Soluções Digitais Inteligentes",
  "hero_title_line1": "Infinity Business — Soluções",
  "hero_title_line2": "Digitais Inteligentes",
  "hero_subtitle": "Conheça o RisTA, seu parceiro digital inteligente",
  "hero_cta": "Falar com RisTA",
  "hero_cta2": "Ver serviços",
  "b2b_title": "Soluções Empresariais (B2B)",
  "p2p_title": "Soluções Pessoais (P2P)",
  "b2b_desc": "Web, mobile, software, hospedagem, design e publicidade",
  "p2p_desc": "Educação cripto, ferramentas de investimento, organização, tradução, branding, domínios",
  "services_title": "Nossos Serviços",
  "services_subtitle": "De soluções web a ferramentas de investimento. O RisTA te guia.",
  "cta_title": "Pronto para construir algo incrível?",
  "cta_subtitle": "Fale com RisTA para um orçamento personalizado.",
  "about": "Sobre",
  "contact": "Contato",
  "privacy": "Privacidade",
  "blog": "Blog",
  "donate": "Doar",
  "booking": "Agendar sessão",
  "login_title": "Bem-vindo de volta",
  "register_title": "Criar conta",
  "login_subtitle": "Entre na sua conta Infinity Business",
  "register_subtitle": "Junte-se ao Infinity Business hoje",
  "auth0_btn": "Continuar com Auth0",
  "or_email": "ou continuar com e-mail",
  "email": "Endereço de e-mail",
  "password": "Senha",
  "full_name": "Nome completo",
  "signin_btn": "Entrar",
  "register_btn": "Criar conta",
  "no_account": "Não tem conta?",
  "have_account": "Já tem conta?",
  "create_one": "Criar uma",
  "sign_in": "Entrar",
  "pricing_title": "Escolha seu plano",
  "pricing_subtitle": "Escale seu negócio. Todos os planos incluem o RisTA.",
  "pay_stripe": "Pagar com Stripe",
  "pay_mypos": "Pagar com myPOS",
  "pay_crypto": "Pagar com Crypto",
  "free_plan": "Plano gratuito atual",
  "most_popular": "Mais popular",
  "dashboard_title": "Minha conta",
  "profile": "Perfil",
  "security": "Segurança (2FA)",
  "subscription": "Assinatura",
  "upgrade": "Upgrade",
  "change_plan": "Mudar plano",
  "twofa_title": "Autenticação de dois fatores",
  "setup_2fa": "Configurar 2FA",
  "disable_2fa": "Desativar 2FA",
  "payment_success": "Pagamento realizado!",
  "payment_cancel": "Pagamento cancelado",
  "footer_copyright": "© 2026 Liber Nostra d.o.o. Todos os direitos reservados.",
  "about_title": "Sobre a Infinity Business",
  "contact_title": "Fale conosco",
  "privacy_title": "Política de Privacidade",
  "send_message": "Enviar mensagem",
  "trade_title": "Nós negociamos por você",
  "trade_desc": "Serviços profissionais de trading de criptomoedas. Fale conosco e agende uma sessão.",
  "back_home": "Voltar ao início",
  "loading": "Carregando...",
  "save": "Salvar",
  "session_expired": "Sua sessão expirou. Por favor, faça login novamente.",
  "nav_services": "Serviços",
  "nav_portal": "Portal",
  "nav_credits": "Créditos",
  "hero_online": "Online",
  "hero_digital_partner": "Parceiro digital",
  "business_solutions": "Soluções empresariais",
  "personal_solutions": "Soluções pessoais",
  "enterprise_desc": "Serviços digitais profissionais para o crescimento do seu negócio.",
  "personal_desc": "Ferramentas de investimento e educação para crescimento pessoal.",
  "services_hero_title": "Nossos serviços",
  "services_hero_desc": "De sites básicos a soluções avançadas de IA. Entregamos excelência digital.",
  "get_started": "Começar",
  "get_a_quote": "Obter orçamento",
  "free_seo_audit": "Auditoria SEO gratuita",
  "ready_to_start": "Pronto para começar?",
  "ready_to_build": "Pronto para criar algo incrível?",
  "ready_to_build_sub": "Fale com RisTA para um orçamento personalizado.",
  "trusted_worldwide": "Confiança mundial",
  "chat_placeholder": "Digite sua mensagem...",
  "chat_suggested_1": "Preciso de um site",
  "chat_suggested_2": "Conte-me sobre os serviços",
  "chat_suggested_3": "Quero um serviço inteligente",
  "chat_suggested_4": "Obter orçamento",
  "trust_platform": "Plataforma confiável",
  "trust_security": "Segurança empresarial",
  "trust_ai": "Tecnologia Inteligente",
  "trust_global": "Alcance global",
  "back_to_home": "Voltar ao início",
  "continue_google": "Continuar com Google",
  "continue_facebook": "Continuar com Facebook",
  "continue_github": "Continuar com GitHub",
  "or_continue_email": "ou continuar com email",
  "two_factor_auth": "Autenticação de dois fatores",
  "enter_2fa_code": "Insira o código do seu aplicativo autenticador",
  "verify_btn": "Verificar código",
  "verifying": "Verificando...",
  "use_different_account": "Usar outra conta",
  "session_expired_msg": "Sua sessão expirou por inatividade.",
  "nav_home": "Início",
  "nav_back": "Voltar",
  "my_account": "Minha conta",
  "sign_out": "Sair",
  "client_portal": "Portal do cliente",
  "your_projects": "Seus projetos",
  "your_invoices": "Suas faturas",
  "projects": "Projetos",
  "invoices_tab": "Faturas",
  "milestones": "Marcos",
  "messages": "Mensagens",
  "no_projects": "Nenhum projeto ainda.",
  "no_invoices": "Nenhuma fatura ainda.",
  "no_messages": "Nenhuma mensagem ainda.",
  "type_message": "Digite uma mensagem...",
  "back_to_projects": "Voltar aos projetos",
  "budget_label": "Orçamento",
  "progress_label": "Progresso",
  "service_label": "Serviço",
  "portal_locked_desc": "O portal está disponível para clientes aprovados.",
  "contact_to_start": "Entre em contato",
  "quick_web_dev": "Desenvolvimento web",
  "quick_mobile": "App móvel",
  "quick_crypto": "Educação cripto",
  "quick_get_quote": "Obter orçamento",
  "quick_tell_more": "Conte-me mais",
  "quick_have_project": "Tenho um projeto",
  "quick_submit": "Enviar solicitação",
  "get_cost_estimate": "Estimativa de custo",
  "choose_plan": "Escolha seu plano",
  "choose_plan_desc": "Expanda seu negócio com o plano certo.",
  "current_free_plan": "Plano gratuito atual",
  "svc_ecommerce_label": "E-Commerce / Loja Online",
  "svc_ecommerce_desc": "Lojas online completas com integração de pagamentos",
  "svc_ecommerce_price": "A partir de €799",
  "svc_seo_label": "SEO e Marketing Digital",
  "svc_seo_desc": "Otimização para motores de busca e estratégia de crescimento",
  "svc_seo_price": "A partir de €299/mês",
  "svc_hosting_label": "Hosting Gerido",
  "svc_hosting_desc": "Infraestrutura de hosting segura, rápida e confiável",
  "svc_hosting_price": "A partir de €29/mês",
  "svc_advertising_label": "Publicidade Digital",
  "svc_advertising_desc": "PPC, anúncios sociais e marketing de performance",
  "svc_advertising_price": "A partir de €499/mês",
  "svc_trading_label": "Consultoria de Trading",
  "svc_trading_desc": "Sessões de estratégia de trading guiadas por especialistas",
  "svc_trading_price": "A partir de €149/sessão",
  "svc_domains_label": "Gestão de Domínios",
  "svc_domains_desc": "Registro de domínios, gestão DNS e transferências",
  "svc_domains_price": "A partir de €19/ano",
  "testimonials_title": "O que dizem nossos clientes",
  "testimonials_subtitle": "Empresas em toda a Europa confiam em nós",
  "stat_projects": "Projetos entregues",
  "stat_satisfaction": "Satisfação do cliente",
  "stat_languages": "Idiomas suportados",
  "all_rights_reserved": "Todos os direitos reservados.",
  "form_your_name": "Seu nome",
  "form_your_email": "Seu email",
  "form_describe_need": "Descreva o que você precisa...",
  "form_additional_feedback": "Feedback adicional? (opcional)",
  "form_email_followup": "Seu email (opcional, para acompanhamento)",
  "form_budget_range": "Faixa de orçamento",
  "form_timeline": "Prazo",
  "form_cancel": "Cancelar",
  "form_select_services": "Selecione os serviços (vários permitidos):",
  "rating_title": "Avalie sua experiência com RisTA",
  "rating_helpful": "Quão útil foi esta conversa?",
  "rating_overall": "Experiência geral com o assistente",
  "rating_recommend": "Você recomendaria o RisTA?",
  "rating_yes": "Sim",
  "rating_no": "Não",
  "rating_submit": "Enviar avaliação",
  "rating_skip": "Pular",
  "rating_thanks": "Obrigado pelo seu feedback!",
  "generating_estimate": "Gerando estimativa de custo...",
  "profile_info": "Informações do perfil",
  "profile_name": "Nome",
  "profile_email": "Email",
  "profile_role": "Função",
  "profile_member_since": "Membro desde",
  "profile_rerun_onboarding": "Repetir introdução",
  "profile_language_pref": "Idioma preferido",
  "profile_language_saved": "Preferência de idioma salva!",
  "privacy_heading": "Política de privacidade",
  "terms_heading": "Termos e condições",
  "about_heading": "Sobre a Infinity Business",
  "walkthrough_heading": "Tutoriais",
  "estimate_title": "Estimativa de custo do projeto",
  "estimate_service": "Serviço",
  "estimate_complexity": "Complexidade",
  "estimate_base_price": "Preço base",
  "estimate_cost": "Custo estimado",
  "estimate_features": "Funcionalidades principais",
  "estimate_accept": "Aceitar e enviar",
  "estimate_revise": "Revisar",
  "submit_service_request": "Enviar sua solicitação",
  "services_cta_title": "Pronto para começar?",
  "services_talk_rista": "Fale com RisTA",
  "services_free_audit": "Auditoria SEO gratuita",
  "nav_tools": "Ferramentas",
  "nav_marketplace": "Marketplace",
  "chat_digital_partner": "Parceiro digital",
  "chat_online": "Online",
  "chat_help_text": "Posso ajudar com desenvolvimento web, apps móveis, design, crypto e mais.",
  "chat_your_partner": "Seu parceiro digital",
  "chat_assistant_subtitle": "Converse com seu assistente IA",
  "tab_password": "Senha",
  "tab_rista_services": "Serviços RisTA",
  "tab_analytics": "Análises",
  "tab_projects": "Projetos",
  "tab_referral": "Programa de indicação",
  "marketplace_title": "Marketplace de modelos",
  "marketplace_subtitle": "Modelos premium personalizáveis. Qualidade profissional, prontos para usar.",
  "marketplace_search": "Buscar modelos...",
  "marketplace_purchase": "Comprar",
  "marketplace_preview": "Visualizar",
  "marketplace_all": "Todos",
  "marketplace_category_website": "Site",
  "marketplace_category_brand": "Marca",
  "marketplace_category_resume": "Currículo",
  "marketplace_downloads": "downloads",
  "marketplace_features": "Recursos",
  "case_studies_title": "Histórias de sucesso",
  "case_studies_subtitle": "Resultados reais de empresas reais. Veja a transformação.",
  "case_studies_before": "Antes",
  "case_studies_after": "Depois",
  "case_studies_cta_title": "Pronto para fazer seu negócio crescer?",
  "case_studies_cta_desc": "Junte-se a essas empresas e obtenha resultados semelhantes com nossos serviços de IA.",
  "case_studies_cta_btn": "Começar",
  "profile_go_homepage": "Ir para a página inicial",
  "onboarding_welcome_title": "Bem-vindo ao Infinity Business",
  "onboarding_welcome_subtitle": "Seu parceiro digital com IA",
  "onboarding_welcome_content": "O Infinity Business oferece serviços digitais B2B e P2P abrangentes. Nosso assistente IA RisTA irá guiá-lo.",
  "onboarding_welcome_item1": "Estimativa de projetos com IA",
  "onboarding_welcome_item2": "Serviços web, mobile e design",
  "onboarding_welcome_item3": "Educação crypto e ferramentas de investimento",
  "onboarding_welcome_item4": "Consultas personalizadas",
  "onboarding_next": "Próximo",
  "onboarding_get_started": "Começar",
  "onboarding_back": "Voltar",
  "onboarding_biz_title": "Seleção de serviços",
  "onboarding_biz_subtitle": "O que melhor descreve suas necessidades?",
  "onboarding_biz_content": "Ajude-nos a recomendar os serviços certos para você:",
  "onboarding_biz_type_startup": "Startup / Novo negócio",
  "onboarding_biz_type_smb": "Pequena-Média empresa",
  "onboarding_biz_type_enterprise": "Grande empresa / Corporação",
  "onboarding_biz_type_freelancer": "Freelancer / Individual",
  "onboarding_biz_type_investor": "Investidor / Entusiasta crypto",
  "change_password_title": "Alterar senha",
  "referral_title": "Programa de indicação",
  "referral_generate": "Gerar meu código de indicação",
  "referral_redeem_title": "Resgatar um código",
  "referral_redeem_btn": "Resgatar",
  "referral_referrals": "Indicações",
  "referral_rewards": "Recompensas",
  "referral_copy_link": "Copiar link",
  "referral_copied": "Copiado!",
  "project_tracker_title": "Acompanhamento de projetos",
  "analytics_total_services": "Total de serviços",
  "analytics_completed": "Concluídos",
  "analytics_pending": "Pendentes",
  "analytics_total_spent": "Total gasto",
  "analytics_credit_balance": "Saldo de créditos",
  "analytics_recent": "Serviços recentes",
  "nav_try_free": "Teste grátis",
  "testimonial_1_text": "RisTA nos ajudou a construir toda a nossa presença na web em apenas 2 semanas.",
  "testimonial_2_text": "O kit de marca e o calendário social nos economizaram meses de trabalho.",
  "testimonial_3_text": "Uso regularmente o criador de CV e as ferramentas de análise. A qualidade da IA é excelente.",
  "services_cta_desc": "Fale com o RisTA, nosso assistente digital inteligente, para obter uma cotacao personalizada.",
  "tools_title": "Ferramentas de marketing gratuitas",
  "tools_subtitle": "Experimente nossas ferramentas gratuitas - sem registro",
  "sp_basic_web_name": "Criacao de site basico",
  "sp_basic_web_desc": "Site profissional para o seu negocio com design moderno e compatibilidade mobile completa.",
  "sp_basic_web_feat": "Design responsivo moderno|Ate 5 paginas|Integracao de formulario de contato|Otimizado para mobile|Configuracao SEO basica|Assistencia na insercao de conteudo",
  "sp_web_store_name": "Loja online / E-Commerce",
  "sp_web_store_desc": "Plataforma e-commerce completa com pagamentos integrados e ferramentas de marketing.",
  "sp_web_store_feat": "Loja online completa|Processamento de pagamentos|Gestao de produtos|Rastreamento de pedidos|Otimizacao SEO|Estrategia de marketing incluida",
  "sp_custom_web_name": "Aplicacao web personalizada",
  "sp_custom_web_desc": "Aplicacoes web sob medida para suas necessidades de negocio.",
  "sp_custom_web_feat": "Design de software personalizado|Integracoes API|Arquitetura de banco de dados|Infraestrutura escalavel|Paineis admin|Suporte continuo",
  "sp_mobile_app_name": "Aplicacao mobile",
  "sp_mobile_app_desc": "Aplicacoes mobile nativas e cross-platform para iOS e Android.",
  "sp_mobile_app_feat": "iOS e Android|Desenvolvimento cross-platform|Notificacoes push|Envio para app stores|Design UI/UX|Integracao backend",
  "sp_seo_name": "SEO e marketing digital",
  "sp_seo_desc": "Aumente sua visibilidade online com estrategias abrangentes de SEO e marketing digital.",
  "sp_seo_feat": "Auditoria SEO completa|Otimizacao de palavras-chave|Estrategia de conteudo|Gestao Google Ads|Marketing em redes sociais|Relatorios mensais",
  "sp_graphic_name": "Design grafico e branding",
  "sp_graphic_desc": "Solucoes completas de branding e design grafico para a identidade do seu negocio.",
  "sp_graphic_feat": "Design de logo|Identidade de marca|Materiais de marketing|Graficos para redes sociais|Design para impressao|Guia de estilo",
  "sp_crypto_edu_name": "Programa de educacao crypto",
  "sp_crypto_edu_desc": "Aprenda trading de criptomoedas e tecnologia blockchain com especialistas.",
  "sp_crypto_edu_feat": "Fundamentos de blockchain|Estrategias de trading|Seguranca de carteira|Introducao DeFi|Analise de mercado|Mentoria pessoal",
  "sp_invest_name": "Ferramentas de investimento inteligentes",
  "sp_invest_desc": "Ferramentas profissionais de rastreamento e analise de investimentos com IA.",
  "sp_invest_feat": "Rastreador de portfolio|Painel de mercado|Insights com IA|Avaliacao de riscos|Alertas em tempo real|Suporte multi-exchange",
  "sp_ad_name": "Servicos de publicidade",
  "sp_ad_desc": "Alcance milhoes atraves da nossa vasta rede de portais em multiplas regioes.",
  "sp_ad_feat": "Rede 20+ portais|10M+ de alcance|Campanhas direcionadas|Rastreamento de performance|Anuncios multi-plataforma|Otimizacao de ROI",
  "contact_heading": "Entre em contato",
  "contact_subtitle_text": "Tem uma pergunta ou quer discutir um projeto? Adorariamos ouvir de voce.",
  "contact_name_label": "Nome",
  "contact_email_label": "Email",
  "contact_subject_label": "Assunto",
  "contact_message_label": "Mensagem",
  "contact_name_ph": "Seu nome",
  "contact_email_ph": "voce@exemplo.com",
  "contact_subject_ph": "Sobre o que e?",
  "contact_message_ph": "Conte-nos sobre seu projeto ou pergunta...",
  "contact_send_btn": "Enviar mensagem",
  "contact_sending": "Enviando...",
  "contact_sent_title": "Mensagem enviada!",
  "contact_sent_msg": "Obrigado por entrar em contato. Responderemos em 24 horas.",
  "contact_send_another": "Enviar outra mensagem",
  "contact_info_email": "Email",
  "contact_info_location": "Localizacao",
  "contact_info_eu": "Uniao Europeia",
  "contact_info_response": "Tempo de resposta",
  "contact_info_response_time": "Dentro de 24 horas",
  "contact_info_hours": "Seg - Sex, 9:00 - 18:00 CET",
  "tf_seo_name": "Auditoria SEO gratuita",
  "tf_seo_desc": "Obtenha uma analise SEO completa de qualquer site - sem registro.",
  "tf_color_name": "Gerador de paleta de cores",
  "tf_color_desc": "Gere paletas de cores bonitas e harmoniosas para sua marca.",
  "tf_headline_name": "Analisador de titulos",
  "tf_headline_desc": "Avalie seus titulos para potencial de cliques e impacto emocional.",
  "tf_chat_name": "Converse com RisTA",
  "tf_chat_desc": "Obtenha estimativas de projetos instantaneas e explore servicos em 11 idiomas.",
  "tf_free_label": "Gratuito",
  "tools_seo_title": "Verificacao SEO rapida",
  "tools_seo_desc": "Pontuacao SEO instantanea para qualquer site",
  "tools_seo_ph": "Insira a URL do site (ex. exemplo.com)",
  "tools_analyze": "Analisar",
  "tools_color_title": "Gerador de paleta de cores",
  "tools_color_desc": "Gere paletas de cores complementares",
  "tools_headline_title": "Analisador de titulos",
  "tools_headline_desc": "Analise a eficacia dos titulos",
  "tools_headline_ph": "Insira seu titulo...",
  "tools_headline_btn": "Analisar titulo",
  "tools_issues": "Problemas encontrados",
  "tools_suggestions": "Sugestoes",
  "tools_score": "Pontuacao",
  "docs_heading": "Funcionalidades da plataforma",
  "docs_subtitle": "Tudo que o Infinity Business oferece para sua jornada digital.",
  "docs_no_data": "Nenhuma documentacao disponivel.",
  "tester_heading": "Torne-se um testador",
  "tester_subtitle": "Ajude-nos a melhorar a plataforma e obtenha acesso gratuito aos servicos.",
  "tester_req_title": "O que e necessario",
  "tester_benefit_title": "O que voce recebe",
  "tester_apply_title": "Candidatar-se",
  "tester_submit_app": "Enviar candidatura",
  "tester_applied_title": "Candidatura enviada",
  "tester_applied_msg": "Nosso admin revisara sua candidatura e voce sera notificado.",
  "tester_need_account": "Voce precisa de uma conta para se candidatar.",
  "tester_dash_title": "Painel do testador",
  "tester_weekly_logins": "Logins semanais",
  "tester_weekly_reports": "Relatorios semanais",
  "tester_target_met": "Meta alcancada!",
  "tester_total_reports": "Total de relatorios enviados",
  "tester_on_track": "No caminho certo",
  "tester_at_risk": "Em risco",
  "tester_report_heading": "Enviar relatorio de bug / feedback",
  "tester_submit_report": "Enviar relatorio",
  "seo_page_title": "Auditoria SEO gratuita",
  "seo_page_btn": "Executar auditoria",
  "seo_page_running": "Analisando...",
  "referral_reward_title": "Como as recompensas funcionam",
  "referral_reward_desc": "Ganhe 10% de cada compra feita por usuarios que voce indicar, creditado automaticamente como creditos gratuitos.",
  "referral_reward_1": "Compartilhe seu link de indicacao unico com amigos",
  "referral_reward_2": "Quando fazem uma compra, voce ganha 10% como creditos gratuitos",
  "referral_reward_3": "Creditos sao adicionados automaticamente ao seu saldo",
  "referral_earned_label": "Creditos ganhos",
  "profile_picture": "Foto de perfil",
  "profile_bio": "Biografia",
  "profile_website": "Site",
  "profile_interests": "Interesses",
  "profile_upload_photo": "Enviar foto",
  "profile_save": "Salvar perfil",
  "admin_notes": "Notas do admin",
  "admin_notes_add": "Adicionar nota",
  "sub_most_popular": "Mais popular",
  "sub_free": "Grátis",
  "sub_one_time": "pagamento único",
  "sub_team_members": "Membros da equipe",
  "sub_members_info": "Convide membros da equipe para compartilhar seu plano. Cada membro recebe seu próprio login e acesso aos serviços.",
  "sub_show_less": "Mostrar menos",
  "sub_more_features": "mais funcionalidades",
  "sub_pay_with": "Pagar com",
  "sub_preferred": "preferido",
  "sub_live_crypto": "Preços cripto ao vivo (EUR e USD)",
  "sp_logo_name": "Design de Logo",
  "sp_logo_desc": "Design de logo profissional que captura a essência da sua marca.",
  "sp_logo_feat": "3 conceitos únicos|Revisões ilimitadas|Arquivos vetoriais|Cor + P&B|Diretrizes da marca|Kit redes sociais",
  "sp_brand_name": "Identidade de Marca Completa",
  "sp_brand_desc": "Pacote completo de identidade de marca com logo, paleta e diretrizes.",
  "sp_brand_feat": "Logo|Paleta de cores|Tipografia|Cartão de visita|Papel timbrado|PDF diretrizes|Templates redes sociais",
  "sp_poster_name": "Design de Poster",
  "sp_poster_desc": "Designs de poster atraentes para eventos e campanhas.",
  "sp_poster_feat": "Ilustração personalizada|Arquivos prontos|Vários tamanhos|2 rodadas de revisão|Alta resolução|Digital + impressão",
  "sp_flyer_name": "Design de Flyer",
  "sp_flyer_desc": "Designs de flyer profissionais para marketing e eventos.",
  "sp_flyer_feat": "Frente e verso|PDF para impressão|Versão digital|Código QR|2 revisões|Vários formatos",
  "sp_menu_name": "Design de Cardápio",
  "sp_menu_desc": "Belos designs de cardápio para restaurantes e cafés.",
  "sp_menu_feat": "Layout personalizado|Integração de fotos|Versão QR|Arquivos para impressão|Atualização sazonal|Várias páginas",
  "currency_label": "Moeda",
  "currency_eur": "EUR",
  "currency_usd": "USD",
  "currency_cny": "CNY",
  "about_intro": "Somos uma empresa de tecnologia focada em soluções digitais inteligentes. Fundada em 2026, a Infinity Business combina inovação em IA com expertise comprovada.",
  "about_values": "Nossos Valores",
  "about_what_we_do": "O Que Fazemos",
  "about_meet_rista": "Conheça a RisTA",
  "about_rista_desc": "RisTA é nossa assistente de IA inteligente. Ajuda a qualificar requisitos, oferece orientação instantânea e conecta você com nossa equipe. Disponível 24/7, multilíngue.",
  "about_talk_rista": "Falar com RisTA",
  "about_val_trust": "Confiança e Segurança",
  "about_val_trust_desc": "Aplicamos os mais altos padrões de proteção de dados.",
  "about_val_innovation": "Inovação",
  "about_val_innovation_desc": "Tecnologia de IA de ponta impulsiona nossas soluções.",
  "about_val_partnership": "Parceria",
  "about_val_partnership_desc": "Trabalhamos ao seu lado como um verdadeiro parceiro.",
  "about_val_global": "Alcance Global",
  "about_val_global_desc": "Nossas soluções são projetadas para mercados internacionais.",
  "about_svc_web": "Desenvolvimento Web",
  "about_svc_web_desc": "Aplicações web, plataformas e-commerce e soluções CMS.",
  "about_svc_mobile": "Aplicações Móveis",
  "about_svc_mobile_desc": "Apps nativos e multiplataforma para iOS e Android.",
  "about_svc_software": "Software Personalizado",
  "about_svc_software_desc": "Soluções de software sob medida para automatizar processos.",
  "about_svc_invest": "Investimentos Inteligentes",
  "about_svc_invest_desc": "Ferramentas crypto e DeFi com IA e serviços profissionais de trading.",
  "micro_tools_title": "Micro-ferramentas IA",
  "micro_tools_subtitle": "Insights instantâneos com IA para geração de leads e planejamento estratégico.",
  "micro_tools_all": "Todas",
  "micro_tools_try": "Experimentar",
  "micro_tools_generate_free": "Gerar (Grátis)",
  "micro_tools_generate_paid": "Gerar",
  "micro_tools_close": "Fechar",
  "micro_tools_interested": "Interessado?",
  "tools_view_service": "Ver serviço",
  "tools_talk_rista": "Falar com RisTA",
  "competitor_title": "Análise de concorrência IA",
  "competitor_desc": "Insira a URL do concorrente para análise IA com comparação SEO e avaliação de design.",
  "competitor_url_ph": "Insira URL do concorrente",
  "competitor_analyze": "Analisar concorrente",
  "competitor_score": "Pontuação geral",
  "competitor_seo": "Análise SEO",
  "competitor_design": "Análise de design",
  "competitor_content": "Análise de conteúdo",
  "competitor_strengths": "Pontos fortes",
  "competitor_weaknesses": "Pontos fracos",
  "competitor_opportunities": "Oportunidades",
  "competitor_recommendations": "Recomendações",
  "accessibility_title": "Verificação de acessibilidade",
  "accessibility_desc": "Verificar padrões de acessibilidade",
  "cat_lead_gen": "Geração de leads",
  "cat_discovery": "Descoberta de relatórios",
  "cat_email": "Email e fluxo de trabalho",
  "cat_planning": "Planejamento e estratégia",
  "cat_content": "Conteúdo e posicionamento",
  "sp_tools_title": "Micro-serviços Inteligentes",
  "sp_tools_desc": "Serviços inteligentes instantâneos para conteúdo, marca, análise e documentos.",
  "sp_free_title": "Ferramentas Gratuitas",
  "sp_free_desc": "Experimente nossa plataforma com estas ferramentas gratuitas.",
  "a11y_checker": "Verificador de acessibilidade",
  "a11y_rescan": "Re-verificar",
  "a11y_scanning": "Executando auditoria WCAG...",
  "a11y_compliant": "Conforme",
  "a11y_passed": "aprovados",
  "a11y_violations": "violações",
  "a11y_incomplete": "precisa de revisão",
  "a11y_issues_found": "Problemas encontrados",
  "a11y_no_issues": "Nenhum problema de acessibilidade encontrado!",
  "a11y_disclaimer": "Verificações automatizadas cobrem ~30% dos problemas. Testes manuais com leitores de tela são recomendados.",
  "a11y_error": "Auditoria falhou. Tente novamente.",
  "admin_ratings": "Avaliações e feedback",
  "admin_timeline": "Cronograma do projeto",
  "admin_add_milestone": "Adicionar marco",
  "admin_milestone_title": "Título do marco",
  "admin_milestone_desc": "Descrição (opcional)",
  "admin_no_milestones": "Sem marcos ainda. Adicione o primeiro!",
  "admin_email_templates_desc": "Personalize modelos de email com o editor visual de blocos.",
  "admin_preloader": "Config. pré-carregamento",
  "admin_image_gen": "Geração de imagem",
  "admin_health_score": "Pontuação de saúde",
  "nav_health_score": "Pontuação de saúde",
  "admin_new": "novo",
  "admin_score": "Pontuação",
  "admin_avg_rating": "Avaliação média",
  "admin_avg_exp": "Experiência média",
  "admin_reviews": "avaliações",
  "admin_out_of": "De",
  "admin_total": "Total",
  "admin_unread": "Não lidos",
  "admin_active": "Ativos",
  "admin_pending": "Pendentes",
  "admin_save": "Salvar",
  "admin_cancel": "Cancelar",
  "admin_delete": "Excluir",
  "admin_edit": "Editar",
  "admin_status": "Status",
  "admin_actions": "Ações",
  "admin_created": "Criado",
  "admin_updated": "Atualizado",
  "admin_view_all": "Ver tudo",
  "admin_no_data": "Sem dados disponíveis",
  "status_planned": "Planejado",
  "status_in_progress": "Em andamento",
  "status_completed": "Concluído",
  "status_blocked": "Bloqueado",
  "priority_low": "Baixa",
  "priority_medium": "Média",
  "priority_high": "Alta",
  "priority_critical": "Crítica",
  "analytics_subscription": "Assinatura",
  "developer_title": "API para desenvolvedores",
  "developer_subtitle": "Integre nossos serviços inteligentes em suas aplicações",
  "hosting_title": "Pacotes de hospedagem",
  "hosting_subtitle": "Hospedagem confiável e rápida para seu negócio",
  "sp_health_score": "Pontuação de saúde do site",
  "sp_health_score_desc": "Análise abrangente do site cobrindo SEO, desempenho, segurança e acessibilidade.",
  "sp_health_score_name": "Pontuação de saúde do site",
  "sp_health_score_feat": "Análise SEO|Verificação de desempenho|Varredura de segurança|Auditoria de acessibilidade|Relatório detalhado|Dicas de melhoria",
  "sp_hosting_name": "Hospedagem web gerenciada",
  "sp_hosting_desc": "Infraestrutura de hospedagem segura, rápida e confiável para seus sites e aplicações.",
  "sp_hosting_feat": "99,9% disponibilidade|Certificados SSL|Backups diários|Integração CDN|Monitoramento 24/7|Escalabilidade automática",
  "sp_biz_plan_name": "Plano de negócios inteligente",
  "sp_biz_plan_desc": "Gere um plano de negócios completo com finanças, análise de mercado e estratégia de crescimento.",
  "sp_biz_plan_feat": "Resumo executivo|Análise de mercado|Projeções financeiras|Visão da concorrência|Estratégia de crescimento|Formato investidor",
  "sp_seo_report_name": "Relatório de auditoria do site",
  "sp_seo_report_desc": "Análise automatizada do site com recomendações SEO acionáveis e insights de desempenho.",
  "sp_seo_report_feat": "100+ pontos de verificação|Métricas de desempenho|Recomendações SEO|Análise móvel|Revisão de segurança|Plano de ação",
  "sp_email_campaign_name": "Configuração de email marketing",
  "sp_email_campaign_desc": "Configuração profissional de campanha de email com textos, sequências e segmentação de público.",
  "sp_email_campaign_feat": "Redação de emails|Configuração de sequências|Segmentação de público|Testes A/B|Configuração analítica|Design de templates",
  "sp_competitor_name": "Análise de concorrência",
  "sp_competitor_desc": "Inteligência competitiva profunda com comparação SEO, revisão de design e análise de lacunas.",
  "sp_competitor_feat": "Comparação SEO|Revisão de design|Lacunas de conteúdo|Posicionamento de mercado|Análise SWOT|Recomendações estratégicas",
  "sp_legal_docs_name": "Gerador de documentos legais",
  "sp_legal_docs_desc": "Modelos legais profissionais incluindo NDA, contratos e Termos de serviço.",
  "sp_legal_docs_feat": "Modelos NDA|Contratos de serviço|Termos de serviço|Políticas de privacidade|Conformidade LGPD|Cláusulas personalizadas",
  "sp_resume_name": "Criador de CV inteligente",
  "sp_resume_desc": "Crie CVs otimizados para ATS adaptados ao seu cargo-alvo e setor.",
  "sp_resume_feat": "Otimização ATS|Templates setoriais|Correspondência de palavras-chave|Carta de apresentação|Otimização LinkedIn|Exportação PDF",
  "sp_brand_kit_name": "Logo e kit de marca inteligente",
  "sp_brand_kit_desc": "Pacote completo de identidade de marca com conceitos de logo, paleta de cores e ativos sociais.",
  "sp_brand_kit_feat": "Conceitos de logo|Paleta de cores|Tipografia|Ativos de redes sociais|Diretrizes de marca|Set de ícones",
  "sp_social_cal_name": "Calendário de redes sociais",
  "sp_social_cal_desc": "30 dias de publicações geradas inteligentemente com estratégia de engajamento.",
  "sp_social_cal_feat": "Calendário 30 dias|Textos de publicação|Estratégia de hashtags|Dicas de engajamento|Melhores horários|Otimização de plataforma",
  "sp_translation_name": "Tradução inteligente",
  "sp_translation_desc": "Tradução profissional de documentos em 50+ idiomas com adaptação cultural.",
  "sp_translation_feat": "50+ idiomas|Adaptação cultural|Termos técnicos|Entrega rápida|Revisão|Preservação de formato",
  "sp_video_script_name": "Escritor de roteiros de vídeo inteligente",
  "sp_video_script_desc": "Roteiros de vídeo envolventes para YouTube, TikTok e anúncios otimizados para máximo engajamento.",
  "sp_video_script_feat": "Roteiros YouTube|Conteúdo TikTok|Texto publicitário|Otimização de gancho|Posicionamento CTA|Dicas de engajamento",
  "sp_free_seo_name": "Auditoria SEO gratuita",
  "sp_free_seo_desc": "Execute uma auditoria SEO completa e gratuita em qualquer site para descobrir oportunidades de otimização.",
  "sp_free_seo_feat": "Resultados instantâneos|100+ verificações|Pontuação de desempenho|Verificação móvel|Varredura de segurança|Relatório gratuito",
  "sp_free_tools_name": "Ferramentas digitais gratuitas",
  "sp_free_tools_desc": "Acesse nossa coleção de ferramentas gratuitas incluindo paletas de cores, analisador de títulos e mais.",
  "sp_free_tools_feat": "Gerador de paletas|Analisador de títulos|Gerador de senhas|Criador de QR code|Conversor de unidades|Sem cadastro",
  "admin_chat_analytics": "Análise de chat",
  "admin_ab_testing": "Testes A/B",
  "admin_ui_toggles": "Controles de UI",
  "admin_audit_trail": "Trilha de auditoria",
  "admin_adv_reports": "Relatórios avançados",
  "admin_rate_limiting": "Limitação de taxa",
  "admin_email_builder": "Construtor de emails",
  "admin_rbac": "Controle de acesso",
  "admin_social_auto": "Automação social",
  "admin_health_monitor": "Monitoramento de saúde",
  "profile_country": "País",
  "profile_country_ph": "ex: Brasil, Portugal, Estados Unidos",
  "health_title": "Pontuação de saúde do site",
  "health_desc": "Análise abrangente de SEO, desempenho, segurança e acessibilidade do seu site em um painel.",
  "health_premium_badge": "Recurso Premium",
  "health_url_ph": "Insira a URL do site (ex: exemplo.com)",
  "health_scan_btn": "Verificar",
  "health_scanning": "Verificando...",
  "health_scan_error": "Falha ao verificar o site. Confira a URL.",
  "health_overall": "Pontuação geral de saúde",
  "health_response": "Resposta",
  "health_size": "Tamanho",
  "health_seo": "SEO",
  "health_perf": "Desempenho",
  "health_security": "Segurança",
  "health_a11y": "Acessibilidade",
  "health_history": "Histórico de verificações",
  "health_login_required": "Faça login para usar a pontuação de saúde",
  "health_login_desc": "Crie uma conta gratuita para verificar seu site e acompanhar melhorias.",
  "health_upsell_title": "Quer monitoramento recorrente?",
  "health_upsell_desc": "Atualize para Premium para verificações semanais automáticas, alertas por email e rastreamento de tendências.",
  "health_upgrade_btn": "Atualizar para Premium",
  "seo_cta_title": "Precisa de ajuda para corrigir esses problemas?",
  "seo_cta_desc": "Nossa auditoria SEO inteligente cobre 100+ pontos de verificação. Obtenha ajuda profissional para otimizar seu site.",
  "walkthrough_gmail": "Assistente inteligente do Gmail",
  "walkthrough_gmail_desc": "Veja como o RisTA organiza sua caixa de entrada",
  "walkthrough_calendar": "Consultor pessoal",
  "walkthrough_calendar_desc": "Calendário, tarefas e email via chat",
  "walkthrough_ai": "Serviços de sistema inteligente",
  "walkthrough_ai_desc": "Currículo, planos de negócios, kits de marca e mais",
  "profile_admin_dashboard": "Abrir painel de administração",
  "profile_appearance": "Aparência e acessibilidade",
  "profile_theme": "Tema",
  "profile_text_size": "Tamanho do texto",
  "profile_text_size_hint": "Ajuste o tamanho do texto para leitura mais fácil.",
  "try_free_title": "Ferramentas gratuitas e serviços de teste",
  "try_free_subtitle": "Sem cartão de crédito. Comece a usar nossas ferramentas agora.",
  "try_free_section": "Totalmente grátis — sem conta necessária",
  "try_free_trial_section": "Serviços de sistema inteligente — Experimente com créditos",
  "try_free_trial_desc": "Inscreva-se em um plano para obter créditos e acesse esses serviços inteligentes.",
  "try_free_cta": "Pronto para começar?",
  "try_free_cta_desc": "Crie uma conta gratuita para receber seus primeiros créditos e desbloquear todos os serviços inteligentes.",
  "try_free_cta_btn": "Inscreva-se grátis",
  "review_title": "O que nossos clientes dizem",
  "review_subtitle": "Feedback real de empresas que ajudamos",
  "testimonial_1_role": "CEO, TechStart d.o.o.",
  "testimonial_2_role": "Diretora de Marketing, BioFresh",
  "testimonial_3_role": "Desenvolvedor Freelance",
  "admin_overview": "Visão geral",
  "admin_my_account": "Minha conta",
  "admin_health": "Monitor de saúde",
  "admin_analytics": "Análise",
  "admin_integrations": "Integrações",
  "admin_requests": "Solicitações de serviço",
  "admin_high_value": "Leads de alto valor",
  "admin_followups": "Emails de acompanhamento",
  "admin_users": "Gerenciamento de usuários",
  "admin_crypto_payments": "Pagamentos cripto",
  "admin_bug_reports": "Relatórios de bugs",
  "admin_pricing": "Preços dinâmicos",
  "admin_defi": "Itens DeFi",
  "admin_chat_sessions": "Sessões de chat",
  "admin_language_requests": "Solicitações de idioma",
  "admin_notifications": "Notificações",
  "admin_sendgrid": "Email (SendGrid)",
  "admin_ai_config": "Config. modelo",
  "admin_live_analytics": "Análise ao vivo",
  "admin_system_config": "Config. sistema",
  "admin_backup": "Backup e restauração",
  "admin_referrals": "Programa de indicação",
  "admin_invoices": "Faturamento",
  "admin_billing": "Cobrança recorrente",
  "admin_blog": "Gerenciador de blog",
  "admin_logo": "Logo e favicon",
  "admin_promo": "Códigos promocionais",
  "admin_currency": "Multi-moeda",
  "admin_domain": "Gerenciador de domínio",
  "admin_cdn": "Gerenciador de CDN",
  "admin_social": "Redes sociais",
  "admin_avatar_selector": "Seletor de avatar",
  "admin_avatar_builder": "Construtor de avatar",
  "admin_client_portal": "Portal do cliente",
  "admin_abandoned_carts": "Carrinhos abandonados",
  "rista_login_required": "Login necessário",
  "rista_login_desc": "Faça login ou crie uma conta para conversar com a RisTA e obter recomendações de negócios personalizadas.",
  "rista_login_btn": "Entrar",
  "rista_signup_btn": "Cadastrar",
  "admin_high_leads": "Leads prioritários",
  "admin_surveys": "Pesquisas de satisfação",
  "admin_rista": "Serviços RisTA",
  "admin_docs": "Documentação",
  "admin_audit": "Auditoria da plataforma",
  "admin_kb": "Base de conhecimento",
  "admin_reports": "Relatórios admin",
  "admin_ad_gen": "Gerador de anúncios",
  "admin_service_mgr": "Gerenciador de serviços",
  "admin_tester": "Programa de testadores",
  "admin_credits": "Config. créditos",
  "admin_account_mgmt": "Gerenciamento de conta",
  "admin_payment_opts": "Opções de pagamento",
  "admin_lead_tracking": "Rastreamento de leads",
  "admin_demo": "Acesso demo",
  "admin_crypto_trading": "Negociação cripto",
  "admin_auto_posting": "Publicação automática inteligente",
  "admin_fb": "Análise FB",
  "admin_referral_board": "Ranking de indicações",
  "admin_escalations": "Escalações de chat",
  "admin_portfolio": "Gerenciador de portfólio",
  "admin_email_templates": "Templates de email",
  "admin_social_icons": "Ícones sociais",
  "admin_ai_prompts": "Prompts inteligentes",
  "admin_panel": "Painel admin",
  "admin_sign_out": "Sair",
  "admin_search_tabs": "Buscar abas...",
  "admin_demo_banner": "MODO SOMENTE LEITURA - Conta de visualização demo (Todos os dados dos usuários estão mascarados)",
  "admin_system_admin": "ADMIN DO SISTEMA",
  "admin_loading": "Carregando...",
  "admin_no_matching": "Nenhuma aba correspondente",
  "tester_req_1": "Faça login pelo menos 5 vezes por semana",
  "tester_req_2": "Envie pelo menos 10 relatórios de bugs/feedback por semana",
  "tester_req_3": "Teste diferentes recursos, páginas e fluxos",
  "tester_benefit_1": "Acesso gratuito aos serviços inteligentes (baseado em solicitações)",
  "tester_benefit_2": "Painel de testador com rastreamento de progresso",
  "tester_benefit_3": "Suporte prioritário da equipe",
  "tester_motivation": "Por que você quer ser um testador?",
  "tester_motivation_ph": "Conte-nos por que gostaria de ajudar a testar a plataforma...",
  "tester_experience": "Experiência em testes (opcional)",
  "tester_experience_ph": "Qualquer experiência relevante...",
  "tester_dash_desc": "Mantenha seu status de testador ativo cumprindo as metas semanais.",
  "tester_logins_needed": "mais logins necessários esta semana",
  "tester_reports_needed": "mais relatórios necessários esta semana",
  "tester_report_title_ph": "Título (ex: 'Botão não clicável no celular')",
  "tester_report_desc_ph": "Descreva o problema ou sugestão em detalhes...",
  "tester_report_page_ph": "URL da página (opcional)",
  "seo_page_desc": "Insira a URL de qualquer site para obter uma análise SEO abrangente com recomendações acionáveis.",
  "seo_page_ph": "Insira a URL do site (ex: exemplo.com)",
  "seo_page_error": "Falha ao auditar este site. Verifique a URL e tente novamente.",
  "profile_bio_ph": "Conte-nos sobre você...",
  "profile_website_ph": "https://seusite.com",
  "profile_interests_ph": "ex: Desenvolvimento web, Cripto, Tecnologia",
  "admin_notes_ph": "Adicione uma nota sobre este usuário...",
  "profile_change_avatar": "Alterar avatar",
  "profile_about": "Sobre você",
  "profile_interests_hint": "Separe interesses com vírgulas",
  "privacy_s1_title": "1. Informações que coletamos",
  "privacy_s2_title": "2. Como usamos suas informações",
  "privacy_s3_title": "3. Compartilhamento de dados",
  "privacy_s4_title": "4. Segurança dos dados",
  "privacy_s5_title": "5. Seus direitos",
  "privacy_s6_title": "6. Cookies e rastreamento",
  "privacy_s7_title": "7. Retenção de dados",
  "privacy_s8_title": "8. Transferências internacionais",
  "privacy_s9_title": "9. Alterações nesta política",
  "privacy_s10_title": "10. Fale conosco",
  "privacy_intro": "Infinity Business (\"nós\"), operado pela Liber Nostra d.o.o., está comprometido em proteger sua privacidade.",
  "privacy_last_updated": "Última atualização: 7 de março de 2026",
  "terms_s1_title": "1. Introdução",
  "terms_s2_title": "2. Serviços",
  "terms_s3_title": "3. Contas de usuário",
  "terms_s4_title": "4. Pagamentos e faturamento",
  "terms_s5_title": "5. Aviso legal de serviços inteligentes",
  "terms_s6_title": "6. Propriedade intelectual",
  "terms_s7_title": "7. Privacidade e dados",
  "terms_s8_title": "8. Aviso legal de criptomoedas",
  "terms_s9_title": "9. Limitação de responsabilidade",
  "terms_s10_title": "10. Modificações",
  "terms_s11_title": "11. Legislação aplicável",
  "terms_s12_title": "12. Contato",
  "terms_last_updated": "Última atualização: fevereiro de 2026",
  "referral_subtitle": "Convide amigos e ganhe recompensas",
  "marketplace_close_preview": "Fechar visualização",
  "marketplace_live_preview": "Visualização ao vivo",
  "billing_management": "Gestão de faturamento",
  "billing_manage_desc": "Gerencie seus métodos de pagamento, veja faturas ou atualize dados de cobrança pelo portal Stripe.",
  "billing_manage_btn": "Gerenciar faturamento",
  "billing_cancel_btn": "Cancelar plano",
  "change_password_current": "Senha atual",
  "change_password_new": "Nova senha",
  "change_password_confirm": "Confirmar nova senha",
  "change_password_btn": "Alterar senha",
  "change_password_social": "A alteração de senha não está disponível para contas de login social.",
  "nav_currency": "Moeda",
  "nav_orders": "Meus pedidos",
  "plan_features": "Recursos do seu plano",
  "project_no_projects": "Sem projetos ainda. Os projetos aparecerão aqui quando você adquirir um serviço.",
  "onboarding_services_title": "Explore nossos serviços",
  "onboarding_services_subtitle": "Duas categorias feitas para você",
  "onboarding_services_content": "Oferecemos duas categorias de serviços:",
  "onboarding_services_item1": "B2B: Desenvolvimento web, aplicativos móveis, design gráfico, hospedagem, software personalizado, anúncios, acesso API",
  "onboarding_services_item2": "P2P: Educação em cripto, soluções DeFi, mercado de domínios, trading gerenciado, ferramentas digitais",
  "onboarding_services_item3": "Micro-ferramentas inteligentes: Snapshots de mercado, análise de concorrentes, geradores de email, esboços de blog, calculadoras TAM e mais",
  "onboarding_services_item4": "Fale com o RisTA a qualquer momento para cotações personalizadas e recomendações de serviços",
  "onboarding_credits_title": "Sistema de créditos",
  "onboarding_credits_subtitle": "Saldo pré-pago para serviços inteligentes",
  "onboarding_credits_content": "Use créditos para acessar nossos serviços inteligentes instantaneamente:",
  "onboarding_credits_item1": "1 EUR = 1 crédito. Básico: 29 créditos, Premium: 79, Vitalício: 499",
  "onboarding_credits_item2": "Ferramentas gratuitas disponíveis sem créditos. Micro-ferramentas pagas custam $1 cada",
  "onboarding_credits_item3": "Descontos por volume: 5% a partir de 50+ EUR, 10% a partir de 100+, 15% a partir de 250+, 20% a partir de 500+",
  "onboarding_credits_item4": "Recarregue com cartão, PayPal, myPOS ou cripto no painel de créditos",
  "onboarding_chat_title": "Fale com o RisTA",
  "onboarding_chat_subtitle": "Seu parceiro digital está pronto",
  "onboarding_chat_content": "O RisTA pode ajudá-lo com:",
  "onboarding_chat_item1": "Obter estimativas e cotações de projetos",
  "onboarding_chat_item2": "Explorar opções de serviços em detalhes",
  "onboarding_chat_item3": "Enviar solicitações de serviço",
  "onboarding_chat_item4": "Responder perguntas em 11 idiomas",
  "support_tickets": "Tickets de suporte",
  "admin_support_tickets": "Tickets de suporte",
  "admin_auto_translate": "Tradução automática",
  "admin_telegram": "Telegram",
  "admin_ai_prospecting": "Prospecção IA",
  "admin_project_mgmt": "Gestão de projetos",
  "admin_analytics_widget": "Widget analítico",
  "admin_doc_mgmt": "Gestão de documentos",
  "admin_webhooks": "Webhooks",
  "admin_white_label": "Marca branca",
  "admin_multi_tenant": "Multi-locatário",
  "popular_services": "Serviços populares",
  "popular_services_desc": "Mais solicitados pelos nossos clientes",
  "purchases": "Compras",
  "admin_funnel": "Funil de conversão",
  "admin_wl_licensing": "Licenças SaaS",
  "admin_analytics_export": "Exportar analíticas",
  "service_detail_features": "O que inclui",
  "service_detail_related": "Serviços relacionados",
  "service_detail_back": "Todos os serviços",
  "checkout_currency": "Moeda de checkout",
  "upsell_title": "Complete sua configuração",
  "upsell_desc": "Clientes que compraram similar também adicionaram:",
  "cart_checkout": "Finalizar",
  "cart_empty": "Seu carrinho está vazio",
  "push_notifications": "Notificações push",
  "push_enabled": "Notificações ativadas",
  "push_disabled": "Ativar notificações",
  "blog_ai_generate": "Geração IA",
  "blog_gen_service": "Gerar para serviço",
  "blog_generating": "Gerando...",
  "export_revenue": "Relatório de receita",
  "export_funnel": "Funil de conversão",
  "export_users": "Lista de utilizadores",
  "export_pdf": "Resumo executivo",
  "license_generate": "Gerar licença",
  "license_revoke": "Revogar",
  "license_renew": "Renovar",
  "license_validate": "Validar",
  "tier_starter": "Starter",
  "tier_professional": "Profissional",
  "tier_enterprise": "Empresarial",
  "blog_subtitle": "Insights, atualizações e guias da Infinity Business.",
  "blog_search_placeholder": "Pesquisar artigos...",
  "blog_all": "Todos",
  "blog_no_posts": "Nenhuma publicação encontrada. Volte em breve!",
  "blog_prev": "Anterior",
  "blog_next": "Próximo",
  "blog_back": "Voltar ao blog",
  "micro_tools": "Micro ferramentas inteligentes",
  "micro_tools_title": "Micro ferramentas inteligentes",
  "micro_tools_subtitle": "Micro ferramentas gratuitas com IA para o seu negócio",
  "color_palette_title": "Gerador de paleta de cores",
  "color_palette_desc": "Gere paletas de cores bonitas para sua marca",
  "color_palette_generate": "Gerar paleta",
  "color_palette_copy": "Copiar",
  "color_palette_copied": "Copiado!",
  "color_palette_hex": "HEX",
  "color_palette_rgb": "RGB",
  "color_palette_hsl": "HSL",
  "color_palette_complementary": "Complementar",
  "color_palette_analogous": "Análogo",
  "color_palette_triadic": "Triádico",
  "color_palette_monochromatic": "Monocromático",
  "admin_menu_overview": "Visão geral",
  "admin_menu_users": "Usuários",
  "admin_menu_blog": "Gerenciador de blog",
  "admin_menu_analytics": "Análise",
  "admin_menu_settings": "Configurações",
  "admin_menu_services": "Serviços",
  "admin_menu_chat": "Sessões de chat",
  "admin_menu_notifications": "Notificações",
  "admin_menu_support": "Suporte",
  "admin_menu_security": "Segurança",
  "admin_menu_backup": "Backup",
  "admin_menu_revenue": "Receita",
  "admin_menu_funnel": "Funil",
  "admin_menu_invoicing": "Faturamento",
  "admin_menu_projects": "Projetos",
  "admin_menu_email": "Editor de e-mail",
  "admin_menu_ai_config": "Config. IA",
  "admin_menu_live_analytics": "Análise ao vivo",
  "admin_menu_platform_audit": "Auditoria da plataforma",
  "docs_title": "Documentação",
  "docs_subtitle": "Aprenda a usar nossa plataforma",
  "try_free_title": "Experimente grátis",
  "try_free_subtitle": "Experimente nossos serviços gratuitamente",
  "subscription_title": "Planos de assinatura",
  "subscription_subtitle": "Escolha o plano ideal para você",
  "portfolio_title": "Portfólio",
  "portfolio_subtitle": "Nosso trabalho fala por si",
  "svc_web-dev_label": "Desenvolvimento Web",
  "svc_web-dev_desc": "Sites, landing pages e aplicações web",
  "svc_mobile-app_label": "Desenvolvimento de Apps Móveis",
  "svc_mobile-app_desc": "Apps iOS & Android, soluções multiplataforma",
  "svc_graphic-design_label": "Design Gráfico",
  "svc_graphic-design_desc": "Logos, branding, materiais de marketing",
  "svc_custom-software_label": "Software Personalizado",
  "svc_custom-software_desc": "Automação empresarial sob medida",
  "svc_ai-business-plan_label": "Gerador de Plano de Negócios",
  "svc_ai-business-plan_desc": "Plano completo com finanças e análise de mercado",
  "svc_ai-seo-report_label": "Auditoria Web e Relatório SEO",
  "svc_ai-seo-report_desc": "Análise automatizada com recomendações",
  "svc_ai-email-campaign_label": "Configuração de Email Marketing",
  "svc_ai-email-campaign_desc": "IA escreve textos e configura sequências de email",
  "svc_ai-competitor-analysis_label": "Relatório de Análise Competitiva",
  "svc_ai-competitor-analysis_desc": "Inteligência de mercado e posicionamento",
  "svc_ai-legal-docs_label": "Gerador de Documentos Legais",
  "svc_ai-legal-docs_desc": "NDA, contratos, modelos de termos de serviço",
  "svc_crypto-education_label": "Educação Cripto",
  "svc_crypto-education_desc": "Aprenda blockchain, DeFi e fundamentos cripto",
  "svc_investment-tools_label": "Ferramentas de Investimento",
  "svc_investment-tools_desc": "Acompanhamento de portfólio e análise de mercado",
  "svc_defi-solutions_label": "Soluções DeFi",
  "svc_defi-solutions_desc": "Contratos inteligentes, yield farming",
  "svc_personal-advertising_label": "Marca Pessoal",
  "svc_personal-advertising_desc": "Construa sua presença online",
  "svc_ai-resume_label": "Construtor de CV Inteligente",
  "svc_ai-resume_desc": "CVs otimizados para ATS",
  "svc_ai-brand-kit_label": "Logo e Kit de Marca Inteligente",
  "svc_ai-brand-kit_desc": "Logo, paleta de cores, tipografia e assets sociais",
  "svc_ai-social-calendar_label": "Calendário de Mídias Sociais",
  "svc_ai-social-calendar_desc": "30 dias de posts gerados por IA",
  "svc_ai-translation_label": "Serviço de Tradução Inteligente",
  "svc_ai-translation_desc": "Tradução profissional em 50+ idiomas",
  "svc_ai-video-script_label": "Escritor de Roteiros de Vídeo",
  "svc_ai-video-script_desc": "Roteiros para YouTube, TikTok e anúncios",
  "admin_grp_dashboard": "Painel",
  "admin_grp_users": "Usuários e acesso",
  "admin_grp_analytics": "Análise e relatórios",
  "admin_grp_services": "Serviços e preços",
  "admin_grp_crypto": "Cripto e DeFi",
  "admin_grp_leads": "Leads e CRM",
  "admin_grp_content": "Conteúdo",
  "admin_grp_comm": "Comunicação",
  "admin_grp_social": "Mídias sociais",
  "admin_grp_ai": "IA e automação",
  "admin_grp_design": "Design e marca",
  "admin_grp_system": "Sistema",
  "admin_grp_projects": "Projetos e QA",
  "color_palette_professional": "Profissional",
  "color_palette_playful": "Lúdico",
  "color_palette_luxury": "Luxo",
  "color_palette_nature": "Natureza",
  "color_palette_tech": "Tecnologia",
  "color_palette_warm": "Quente",
  "color_palette_cool": "Frio",
  "blog_translating": "Traduzindo artigo...",
  "blog_translated_cached": "Traduzido",
  "blog_translated_fresh": "Recém traduzido",
  "blog_show_original": "Mostrar original",
  "privacy_s1_content": "Coletamos informações que você nos fornece diretamente, incluindo:\n- **Informações da conta**: Nome, e-mail e senha.\n- **Solicitações de serviço**: Detalhes do projeto, orçamento e contato.\n- **Informações de pagamento**: Dados processados por nossos parceiros (Stripe, myPOS).\n- **Dados de comunicação**: Mensagens via RisTA, formulários e e-mails.\n- **Dados de uso**: Tipo de navegador, IP, páginas visitadas.",
  "privacy_s2_content": "Usamos as informações coletadas para:\n- Fornecer, manter e melhorar nossos serviços\n- Processar transações\n- Enviar avisos técnicos e suporte\n- Responder suas perguntas\n- Monitorar tendências e atividades\n- Detectar e prevenir fraudes\n- Personalizar sua experiência com RisTA",
  "privacy_s3_content": "Não vendemos suas informações pessoais. Podemos compartilhar com:\n- **Prestadores de serviço**: Empresas que realizam serviços em nosso nome.\n- **Requisitos legais**: Quando exigido por lei.\n- **Transferências comerciais**: Em conexão com fusões ou vendas.\n- **Consentimento**: Com seu consentimento explícito.",
  "privacy_s4_content": "Implementamos medidas de segurança padrão:\n- Criptografia de dados em trânsito (TLS/SSL) e em repouso\n- Suporte a autenticação de dois fatores (2FA)\n- Auditorias de segurança regulares\n- Controles de acesso e autenticação\n- Processamento seguro de pagamentos",
  "privacy_s5_content": "Sob as leis de proteção de dados (incluindo GDPR), você tem direito a:\n- **Acesso**: Solicitar cópia dos seus dados\n- **Retificação**: Solicitar correção de dados imprecisos\n- **Eliminação**: Solicitar exclusão dos dados\n- **Restrição**: Solicitar restrição do processamento\n- **Portabilidade**: Solicitar transferência em formato legível\n- **Objeção**: Opor-se ao processamento\n- **Retirada de consentimento**: Retirar consentimento a qualquer momento\n\nContate-nos: privacy@infinitybusiness.org.",
  "privacy_s6_content": "Usamos cookies essenciais para sua sessão e preferências. Você pode gerenciar cookies pelo navegador.",
  "privacy_s7_content": "Retemos seus dados apenas pelo tempo necessário para cumprir os fins da coleta.",
  "privacy_s8_content": "Seus dados podem ser transferidos para fora do EEE. Garantimos salvaguardas adequadas.",
  "privacy_s9_content": "Podemos atualizar esta política periodicamente. Mudanças materiais serão publicadas nesta página.",
  "privacy_s10_content": "Para perguntas, contate:\n\n**Liber Nostra d.o.o.**\nEmail: privacy@infinitybusiness.org\nSite: infinitybusiness.org",
  "terms_s1_content": "Bem-vindo ao Infinity Business (\"infinitybusiness.org\"), operado por **Liber Nostra d.o.o.**. Ao acessar nossa plataforma, você concorda com estes Termos.",
  "terms_s2_content": "Infinity Business oferece serviços digitais com IA:\n- Desenvolvimento web, apps móveis e design gráfico (B2B)\n- Serviços empresariais e publicidade digital\n- Educação cripto, ferramentas de investimento e DeFi (P2P)\n- Assistente IA RisTA\n- Domínios e hospedagem web",
  "terms_s3_content": "Para certas funcionalidades é necessário criar uma conta. Você é responsável pela confidencialidade de suas credenciais.",
  "terms_s4_content": "Serviços podem requerer pagamento. Pagamentos via terceiros (Stripe, PayPal, cripto). Políticas de reembolso:\n- **Serviços únicos**: Não reembolsáveis.\n- **Assinaturas**: Canceláveis a qualquer momento.\n- **Projetos personalizados**: Conforme acordo individual.",
  "terms_s5_content": "Nosso assistente IA \"RisTA\" fornece orientação automatizada. Apenas para fins informativos.",
  "terms_s6_content": "Todo o conteúdo desta plataforma é propriedade da Liber Nostra d.o.o.",
  "terms_s7_content": "Seu uso também é regido por nossa Política de Privacidade.",
  "terms_s8_content": "Serviços relacionados a cripto são apenas informativos. Não fornecemos consultoria financeira.",
  "terms_s9_content": "Liber Nostra d.o.o. não será responsável por danos indiretos ou consequentes.",
  "terms_s10_content": "Reservamo-nos o direito de modificar estes Termos a qualquer momento.",
  "terms_s11_content": "Estes Termos são regidos pelas leis da República da Eslovênia.",
  "terms_s12_content": "Para perguntas, entre em contato ou escreva para support@infinitybusiness.org.",
  "admin_ad_generator": "Gerador de Anúncios",
  "admin_add": "Adicionar",
  "admin_add_prompt": "Adicionar Prompt",
  "admin_admin": "Admin",
  "admin_advanced_reporting": "Relatórios Avançados",
  "admin_all": "Tudo",
  "admin_analytics_dashboard": "Dashboard de Analytics",
  "admin_api_key": "API Key",
  "admin_apply": "Aplicar",
  "admin_approved": "Aprovado",
  "admin_archive": "Arquivar",
  "admin_are_you_sure": "Tem certeza?",
  "admin_audit_alerts": "Alertas de Auditoria",
  "admin_author": "Autor",
  "admin_avg_session": "Sessão Média",
  "admin_back": "Voltar",
  "admin_badge": "Badge",
  "admin_balance": "Saldo",
  "admin_banned": "Banido",
  "admin_blog_manager": "Gerenciador de Blog",
  "admin_body": "Body",
  "admin_bounce_rate": "Taxa de Rejeição",
  "admin_browser": "Navegador",
  "admin_campaign": "Campanha",
  "admin_cannot_undo": "Esta ação não pode ser desfeita",
  "admin_category": "Categoria",
  "admin_click_rate": "Taxa de Clique",
  "admin_close": "Fechar",
  "admin_completed": "Concluído",
  "admin_configuration": "Configuração",
  "admin_confirm": "Confirmar",
  "admin_contact_info": "Informações de Contato",
  "admin_content": "Conteúdo",
  "admin_conversations": "Conversas",
  "admin_conversion_funnel": "Funil de Conversão",
  "admin_conversion_rate": "Taxa de Conversão",
  "admin_copied": "Copiado para a área de transferência",
  "admin_copy": "Copiar",
  "admin_count": "Contagem",
  "admin_country": "País",
  "admin_create": "Criar",
  "admin_create_experiment": "Criar Experimento",
  "admin_create_new": "Criar Novo",
  "admin_created_success": "Criado com sucesso",
  "admin_credit_config": "Configuração de Crédito",
  "admin_critical": "Crítica",
  "admin_custom": "Personalizado",
  "admin_daily": "Diário",
  "admin_date": "Data",
  "admin_delete_failed": "Falha ao excluir",
  "admin_deleted_success": "Excluído com sucesso",
  "admin_demo_access": "Acesso de Demo",
  "admin_description": "Descrição",
  "admin_deselect_all": "Desmarcar Tudo",
  "admin_details": "Detalhes",
  "admin_device": "Dispositivo",
  "admin_disable": "Desativar",
  "admin_disabled": "Desativado",
  "admin_doc_viewer": "Visualizador de Documentos",
  "admin_documentation": "Documentação",
  "admin_download": "Baixar",
  "admin_draft": "Rascunho",
  "admin_duplicate": "Duplicar",
  "admin_email": "Email",
  "admin_enable": "Ativar",
  "admin_enabled": "Ativado",
  "admin_end_date": "Data de Término",
  "admin_endpoint": "Endpoint",
  "admin_error": "Erro",
  "admin_escalation_queue": "Fila de Escalonamento",
  "admin_event": "Evento",
  "admin_events": "Eventos",
  "admin_experiment_name": "Nome do Experimento",
  "admin_export": "Exportar",
  "admin_facebook_analytics": "Facebook Analytics",
  "admin_false": "Falso",
  "admin_filter": "Filtrar",
  "admin_frequency": "Frequência",
  "admin_generate": "Gerar",
  "admin_headers": "Headers",
  "admin_health_monitoring": "Monitoramento de Saúde",
  "admin_high": "Alta",
  "admin_high_value_leads": "Leads de Alto Valor",
  "admin_id": "ID",
  "admin_image": "Imagem",
  "admin_import": "Importar",
  "admin_in_progress": "Em Andamento",
  "admin_inactive": "Inativo",
  "admin_inbox": "Caixa de Entrada Admin",
  "admin_speed_audit": "Auditoria de Velocidade",
  "admin_info": "Info",
  "admin_ip_address": "Endereço IP",
  "admin_joined": "Entrou em",
  "admin_knowledge_base": "Base de Conhecimento",
  "admin_language": "Idioma",
  "admin_last_activity": "Última Atividade",
  "admin_last_login": "Último Login",
  "admin_last_triggered": "Último Acionamento",
  "admin_lead_score": "Lead Score",
  "admin_level": "Nível",
  "admin_load_failed": "Falha ao carregar",
  "admin_loading_data": "Carregando dados...",
  "admin_low": "Baixa",
  "admin_medium": "Média",
  "admin_messages": "Mensagens",
  "admin_method": "Method",
  "admin_monetization": "Monetização",
  "admin_monthly": "Mensal",
  "admin_name": "Nome",
  "admin_next": "Próximo",
  "admin_no": "Não",
  "admin_no_data_available": "Nenhum dado disponível",
  "admin_no_experiments": "Nenhum experimento encontrado",
  "admin_no_leads": "Nenhum lead encontrado",
  "admin_no_prompts": "Nenhum prompt encontrado",
  "admin_no_results": "Sem resultados",
  "admin_no_results_found": "Nenhum resultado encontrado",
  "admin_none": "Nenhum",
  "admin_off": "Desligado",
  "admin_on": "Ligado",
  "admin_open_rate": "Taxa de Abertura",
  "admin_page_views": "Visualizações de Página",
  "admin_partner_badges": "Badges de Parceiro",
  "admin_payload": "Payload",
  "admin_payment_options": "Opções de Pagamento",
  "admin_platform": "Plataforma",
  "admin_platform_audit": "Auditoria da Plataforma",
  "admin_points": "Pontos",
  "admin_portfolio_manager": "Gerenciador de Portfólio",
  "admin_preloader_config": "Configuração de Preloader",
  "admin_preview": "Visualizar",
  "admin_previous": "Anterior",
  "admin_price": "Preço",
  "admin_priority": "Prioridade",
  "admin_prompt_name": "Nome do Prompt",
  "admin_prompt_text": "Texto do Prompt",
  "admin_published": "Publicado",
  "admin_recipients": "Destinatários",
  "admin_referral": "Referência",
  "admin_referral_leaderboard": "Ranking de Indicações",
  "admin_refresh": "Atualizar",
  "admin_rejected": "Rejeitado",
  "admin_remove": "Remover",
  "admin_reset": "Redefinir",
  "admin_response_time": "Tempo de Resposta",
  "admin_restore": "Restaurar",
  "admin_results": "Resultados",
  "admin_retry": "Repetir",
  "admin_revenue_dashboard": "Dashboard de Receita",
  "admin_rista_services": "Serviços RisTA",
  "admin_role": "Função",
  "admin_save_changes": "Salvar Alterações",
  "admin_save_failed": "Falha ao salvar",
  "admin_saved_success": "Salvo com sucesso",
  "admin_scheduled": "Agendado",
  "admin_search": "Buscar",
  "admin_select": "Selecionar",
  "admin_select_all": "Selecionar Tudo",
  "admin_send": "Enviar",
  "admin_sent_success": "Enviado com sucesso",
  "admin_server_resources": "Recursos do Servidor",
  "admin_service_manager": "Gerenciador de Serviços",
  "admin_session_duration": "Duração da Sessão",
  "admin_settings": "Configurações",
  "admin_slug": "Slug",
  "admin_social_automation": "Automação Social",
  "admin_something_wrong": "Algo deu errado",
  "admin_source": "Origem",
  "admin_start_date": "Data de Início",
  "admin_subject": "Assunto",
  "admin_submit": "Enviar",
  "admin_subscribers": "Assinantes",
  "admin_success": "Sucesso",
  "admin_suspended": "Suspenso",
  "admin_system_prompt": "System Prompt",
  "admin_tags": "Tags",
  "admin_template": "Template",
  "admin_templates": "Templates",
  "admin_test_results": "Resultados do Teste",
  "admin_tester_program": "Programa de Testers",
  "admin_title": "Título",
  "admin_total_revenue": "Receita Total",
  "admin_total_sessions": "Total de Sessões",
  "admin_total_users": "Total de Usuários",
  "admin_trigger": "Trigger",
  "admin_true": "Verdadeiro",
  "admin_try_again": "Por favor, tente novamente",
  "admin_type": "Tipo",
  "admin_unique_visitors": "Visitantes Únicos",
  "admin_unsubscribed": "Cancelamentos de Assinatura",
  "admin_unverified": "Não verificado",
  "admin_update": "Atualizar",
  "admin_updated_success": "Atualizado com sucesso",
  "admin_upload": "Carregar",
  "admin_urgent": "Urgente",
  "admin_user": "Usuário",
  "admin_variant_a": "Variante A",
  "admin_variant_b": "Variante B",
  "admin_verified": "Verificado",
  "admin_version": "Versão",
  "admin_view": "Ver",
  "admin_view_details": "Ver Detalhes",
  "admin_viewer": "Visualizador",
  "admin_warning": "Aviso",
  "admin_webhook_url": "Webhook URL",
  "admin_weekly": "Semanal",
  "admin_yes": "Sim",
  "admin_analytics_digestadmin_analytics_digest": "Resumo analitico",
  "admin_blog_health": "Saude do blog",
  "credit_title": "Créditos",
  "credit_subtitle": "Saldo pré-pago para serviços inteligentes",
  "credit_available_balance": "Saldo disponível",
  "credit_tab_balance": "Saldo",
  "credit_tab_topup": "Recarregar",
  "credit_tab_history": "Histórico",
  "credit_tab_services": "Serviços",
  "credit_tab_crypto": "Cripto",
  "credit_balance_desc": "Seu crédito pode ser usado para qualquer serviço de IA:",
  "credit_bulk_discounts": "Descontos por volume",
  "credit_add_credits": "Adicionar créditos",
  "credit_select_amount": "Selecione um valor ou insira um valor personalizado:",
  "credit_bonus": "bônus",
  "credit_bonus_detail": "Você receberá",
  "credit_total_word": "total",
  "credit_method_card": "Cartão",
  "credit_method_crypto": "Cripto",
  "credit_processing": "Processando...",
  "credit_add_btn": "Adicionar",
  "credit_no_txn": "Nenhuma transação",
  "credit_txn_topup": "Recarga",
  "credit_txn_promo": "Crédito promo",
  "credit_txn_auto": "Compra automática",
  "credit_txn_purchase": "Compra",
  "credit_svc_intelligent": "Serviço inteligente",
  "credit_svc_available": "Disponível",
  "credit_svc_need_more": "Precisa de",
  "credit_svc_more": "mais",
  "credit_crypto_send": "Enviar",
  "credit_crypto_amount": "Valor:",
  "credit_crypto_equivalent": "equivalente",
  "credit_crypto_network": "Rede:",
  "credit_crypto_wallet": "Endereço da carteira",
  "credit_crypto_confirm": "Os créditos serão adicionados após a confirmação da transação.",
  "credit_payment_id": "ID do pagamento:",
  "credit_crypto_back": "Voltar à seleção de cripto",
  "credit_crypto_select_title": "Selecione criptomoeda para recarga",
  "credit_crypto_choose_desc": "Escolha uma moeda. Você receberá um endereço de carteira para pagamento.",
  "credit_crypto_select_btn": "Selecionar",
  "credit_minimum": "Mínimo €5",
  "credit_redirecting": "Redirecionando...",
  "credit_topup_failed": "Falha na recarga",
  "credit_crypto_failed": "Falha ao iniciar pagamento cripto",
  "cart_title": "Carrinho",
  "cart_total": "Total",
  "cart_stripe_checkout": "Pagamento Stripe",
  "cart_credits": "Créditos",
  "cart_secure_stripe": "Pagamento seguro Stripe",
  "cart_insufficient": "Créditos insuficientes. Recarregue primeiro ou escolha pagamento por cartão.",
  "cart_pay_card": "Pagar com cartão",
  "cart_pay_credits_btn": "Pagar com créditos",
  "cart_clear": "Limpar carrinho",
  "cart_processing": "Processando...",
  "cart_payment_success": "Pagamento bem-sucedido! Seu pedido está sendo processado.",
  "cart_complete_setup": "Complete sua configuração",
  "cart_also_added": "Clientes com compras similares também adicionaram:",
  "cart_add": "Adicionar",
  "cart_standard": "Padrão",
  "cart_remaining_balance": "Saldo restante:",
  "cart_checkout_failed": "Falha no pagamento",
  "cart_checkout_no_session": "Não foi possível criar sessão de pagamento",
  "cart_purchased": "Comprado",
  "cart_services_with_credits": "serviço(s) com créditos!",
  "credits_balance_title": "Saldo de créditos",
  "credits_topup_btn": "Recarregar créditos",
  "credits_rate": "1 EUR = 1 Crédito",
  "credits_total_topup": "Total recarregado",
  "credits_spent_credits": "Gasto (Créditos)",
  "credits_spent_payments": "Gasto (Pagamentos)",
  "credits_txn_history": "Histórico de transações",
  "credits_no_txn": "Nenhuma transação",
  "credits_txn_topup": "Recarga",
  "credits_txn_promo": "Crédito promo",
  "credits_txn_purchase": "Compra de serviço",
  "credits_txn_ai": "Serviço IA",
  "credits_order_history": "Histórico de pedidos",
  "credits_order_label": "Pedido:",
  "chat_translate_btn": "Traduzir para inglês",
  "chat_translating": "Traduzindo...",
  "chat_translated_label": "Tradução em inglês exibida. Clique em \"Mostrar original\" para as mensagens originais.",
  "chat_show_original": "Mostrar original",
  "chat_show_translated": "Mostrar tradução",
  "pkg_section_badge": "Ofertas por Tempo Limitado",
  "pkg_section_title": "Lance Seu Negócio",
  "pkg_section_title_highlight": "Hoje",
  "pkg_section_subtitle": "Pacotes premium projetados para te colocar online rapidamente — com tecnologia inteligente embutida desde o primeiro dia.",
  "pkg_section_footer": "Todos os preços excluem VAT onde aplicável. Não tem certeza de qual pacote se encaixa? Converse com a RisTA para uma consulta gratuita.",
  "pkg_cta_default": "Começar",
  "admin_package_mgr": "Gerenciador de Pacotes",
  "admin_pkg_title": "Pacotes de Página de Destino",
  "admin_pkg_subtitle": "Gerencie pacotes de preços destacados exibidos na página de destino",
  "admin_pkg_seed": "Definições Padrão",
  "admin_pkg_new": "Novo Pacote",
  "admin_pkg_create_title": "Criar Novo Pacote",
  "admin_pkg_edit_title": "Editar Pacote",
  "admin_pkg_name": "Nome do Pacote",
  "admin_pkg_tagline": "Slogan",
  "admin_pkg_description": "Descrição",
  "admin_pkg_price": "Preço",
  "admin_pkg_currency": "Moeda",
  "admin_pkg_price_note": "Observação sobre o Preço",
  "admin_pkg_badge": "Emblema",
  "admin_pkg_accent": "Cor de Acento",
  "admin_pkg_cta_text": "Texto do Botão CTA",
  "admin_pkg_cta_link": "Link CTA (opcional)",
  "admin_pkg_sort": "Ordem de Classificação",
  "admin_pkg_features": "Recursos / Serviços Incluídos",
  "admin_pkg_add_feature": "Adicionar Recurso",
  "admin_pkg_highlighted": "Destacado",
  "admin_pkg_normal": "Normal",
  "admin_pkg_create": "Criar Pacote",
  "admin_pkg_save": "Salvar Alterações",
  "admin_pkg_saving": "Salvando...",
  "admin_pkg_cancel": "Cancelar",
  "admin_pkg_empty_title": "Nenhum pacote configurado ainda",
  "admin_pkg_empty_desc": "Clique em Seed Defaults para gerar dois pacotes iniciais ou crie o seu próprio.",
  "admin_pkg_features_label": "recursos",
  "admin_pkg_sort_label": "Classificar",
  "admin_pkg_delete_confirm": "Excluir este pacote? Ele será removido da página de destino.",
  "admin_pkg_feature_placeholder": "Descrição do recurso...",
  "admin_pkg_pricenote_placeholder": "ex. Uma vez / +5% de participação nos lucros",
  "admin_pkg_badge_placeholder": "ex. MELHOR VALOR",
  "admin_pkg_loading": "Carregando pacotes...",
  "pkg_qa_have_domain": "Sim, tenho um dom00ednio",
  "pkg_qa_need_domain": "Preciso de um dom00ednio",
  "pkg_qa_describe_biz": "Deixe-me descrever meu neg00f3cio",
  "pkg_qa_more_info": "Conte-me mais sobre este pacote",
  "sp_addon_title": "Add-ons e Suporte",
  "sp_addon_desc": "Potencialize seu projeto com suporte prioritário e consultoria especializada.",
  "sp_research_title": "Produtos de Pesquisa Inteligente",
  "sp_research_desc": "Inteligência de mercado sob demanda e ferramentas de análise inteligente.",
  "tier_section_badge": "Pacotes Inteligentes",
  "tier_section_title": "Escolha Seu",
  "tier_section_highlight": "Plano de Crescimento",
  "tier_section_subtitle": "Pacotes projetados para entregar valor máximo. Escolha o nível ideal para você.",
  "tier_one_time": "Pagamento Único",
  "tier_monthly": "Mensal",
  "tier_section_footer": "Todos os preços excluem IVA. Precisa de um pacote personalizado? Converse com RisTA.",
  "tier_name_starter": "Starter",
  "tier_name_growth": "Growth",
  "tier_name_pro": "Pro",
  "tier_name_enterprise": "Enterprise",
  "tier_tag_starter": "Perfeito para começar sua presença digital",
  "tier_tag_growth": "Escale seu negócio com ferramentas inteligentes",
  "tier_tag_pro": "Crescimento digital completo para negócios sérios",
  "tier_tag_enterprise": "Transformação digital completa",
  "tier_cta_starter": "Obter Starter",
  "tier_cta_growth": "Obter Growth",
  "tier_cta_pro": "Obter Pro",
  "tier_cta_enterprise": "Obter Enterprise",
  "tier_badge_popular": "POPULAR",
  "tier_badge_best": "MELHOR VALOR",
  "tier_badge_all": "TUDO EM UM",
  "tier_per_mo": "mês",
  "tier_once_label": "pagamento único",
  "tier_or_monthly": "ou",
  "tier_f_starter_1": "Gerador inteligente de plano de negócios",
  "tier_f_starter_2": "Construtor inteligente de CV (3 unid.)",
  "tier_f_starter_3": "Auditoria web e relatório SEO",
  "tier_f_starter_4": "Logo e kit de marca inteligente",
  "tier_f_starter_5": "Relatório panorama do mercado",
  "tier_f_starter_6": "Rascunho de respostas FAQ",
  "tier_f_starter_7": "Esboço de blog a partir de tendência",
  "tier_f_starter_8": "Suporte email em 48h",
  "tier_f_growth_1": "Tudo do Starter",
  "tier_f_growth_2": "Campanha de email inteligente",
  "tier_f_growth_3": "Calendário e análise redes sociais (3 meses)",
  "tier_f_growth_4": "Relatório análise competitiva",
  "tier_f_growth_5": "Gerador de anúncios (5 campanhas)",
  "tier_f_growth_6": "Gerador de emails de alcance",
  "tier_f_growth_7": "Explicador de tendências",
  "tier_f_growth_8": "Análise de posicionamento",
  "tier_f_growth_9": "Suporte email prioritário em 24h",
  "tier_f_pro_1": "Tudo do Growth",
  "tier_f_pro_2": "Setup SEO e marketing digital",
  "tier_f_pro_3": "Setup email marketing",
  "tier_f_pro_4": "Escritor inteligente de roteiros (5 unid.)",
  "tier_f_pro_5": "Esboço rápido lógica TAM",
  "tier_f_pro_6": "Checklist de riscos",
  "tier_f_pro_7": "Priorização de funcionalidades",
  "tier_f_pro_8": "Rascunho lista de fornecedores",
  "tier_f_pro_9": "Sessão consultoria inteligente (2h)",
  "tier_f_pro_10": "Suporte prioritário em 12h",
  "tier_f_ent_1": "Tudo do Pro",
  "tier_f_ent_2": "Desenvolvimento de software customizado",
  "tier_f_ent_3": "Estratégia publicitária enterprise",
  "tier_f_ent_4": "Hosting gerenciado (12 meses)",
  "tier_f_ent_5": "Plano de manutenção (6 meses)",
  "tier_f_ent_6": "Consultoria inteligente (10h)",
  "tier_f_ent_7": "Verificação entrada no país",
  "tier_f_ent_8": "Resumo executivo para slides",
  "tier_f_ent_9": "Declaração de problema JTBD",
  "tier_f_ent_10": "Gerente de conta dedicado",
  "tier_f_ent_11": "Fila prioritária (resposta 4h)",
  "calc_title": "Calculadora de Preços",
  "calc_subtitle": "Compare serviços individuais com pacotes para ver suas economias.",
  "calc_badge": "Economize Mais",
  "calc_select_services": "Selecionar Serviços",
  "calc_search_placeholder": "Buscar serviços...",
  "calc_selected": "selecionados",
  "calc_your_selection": "Sua Seleção",
  "calc_individual_total": "Total Individual",
  "calc_best_tier": "Melhor Pacote",
  "calc_you_save": "Você Economiza",
  "calc_no_services": "Selecione serviços para ver economias",
  "calc_clear_all": "Limpar tudo",
  "calc_get_tier": "Obter Este Pacote",
  "calc_individual_cheaper": "Os serviços individuais já são econômicos. Adicione mais para desbloquear economias!",
  "referred_by": "Indicado por",
  "referral_signup_reward": "Cadastre-se para conectar sua conta com esta indicacao.",
  "badge_coming_soon": "Em breve",
  "badge_available_soon": "Disponível em breve",
  "badge_from_price": "a partir de",
  "badge_preparing": "Estamos preparando este serviço para você",
  "svc_managed-hosting_label": "Hospedagem gerenciada",
  "svc_managed-hosting_desc": "Hospedagem totalmente gerenciada com monitoramento e suporte",
  "svc_enterprise-advertising_label": "Publicidade empresarial",
  "svc_enterprise-advertising_desc": "Campanhas publicitárias em grande escala com estratégia dedicada",
  "svc_email-marketing_label": "Configuração de email marketing",
  "svc_email-marketing_desc": "Sequências de email, templates e automação profissionais",
  "svc_competitor-analysis_label": "Relatório de análise competitiva",
  "svc_competitor-analysis_desc": "Inteligência de mercado e posicionamento competitivo",
  "svc_legal-docs_label": "Gerador de documentos legais",
  "svc_legal-docs_desc": "NDA, contratos, modelos de termos de serviço",
  "svc_website-audit_label": "Auditoria web e relatório SEO",
  "svc_website-audit_desc": "Análise completa do site com recomendações",
  "svc_trading-consultation_label": "Consultas de trading",
  "svc_trading-consultation_desc": "Sessões de estratégia de trading guiadas por especialistas",
  "svc_managed-trading_label": "Trading gerenciado",
  "svc_managed-trading_desc": "Trading gerenciado por especialistas com estratégias comprovadas",
  "svc_domain-management_label": "Gestão de domínios",
  "svc_domain-management_desc": "Registro de domínios, gestão DNS e transferências",
  "svc_personal-branding_label": "Marca pessoal",
  "svc_personal-branding_desc": "Construa sua presença online e marca pessoal",
  "admin_escalation_alert": "Escalação de chat",
  "admin_view_escalations": "Ver fila de escalações",
  "from": "A partir de",
  "vector_gen_title": "Gerador vetorial",
  "vector_gen_title_hl": "inteligente",
  "vector_gen_badge": "Estúdio vetorial inteligente",
  "vector_gen_desc": "Descreva sua ideia, carregue referências e obtenha um gráfico vetorial SVG pronto para produção em segundos.",
  "vector_gen_balance": "Seu saldo",
  "vector_gen_per_gen": "créditos por geração",
  "vector_gen_prompt_label": "Descreva seu gráfico vetorial",
  "vector_gen_prompt_ph": "ex. Um logo minimalista de montanha com raios de sol, usando cores teal e laranja...",
  "vector_gen_style": "Estilo",
  "vector_gen_color": "Modo de cor",
  "vector_gen_refs": "Arquivos de referência",
  "vector_gen_optional": "opcional, máx. 3",
  "vector_gen_upload": "Carregar referência (PNG, JPG, SVG)",
  "vector_gen_generating": "Gerando...",
  "vector_gen_cta": "Gerar vetor",
  "vector_gen_result": "Seu gráfico vetorial",
  "vector_gen_model_used": "Modelo",
  "vector_gen_history": "Histórico de geração",
  "vector_gen_no_history": "Nenhuma geração ainda",
  "vector_gen_login_req": "Faça login para usar o gerador vetorial.",
  "vector_gen_service_title": "Precisa de vetores profissionais?",
  "vector_gen_service_desc": "Encomende gráficos vetoriais personalizados como serviço completo de design com revisões e diretrizes de marca.",
  "vector_gen_service_cta": "Ver serviços de design",
  "vector_gen_product_type": "Tipo de produto",
  "vector_gen_size": "Tamanho de saída",
  "vector_gen_error_prompt": "Por favor descreva sua ideia de gráfico vetorial.",
  "admin_vector_gen": "Gerador vetorial",
  "admin_showroom": "Showroom",
  "admin_landing_page": "Pagina inicial",
  "admin_landing_text": "Textos pagina inicial",
  "admin_vector_title": "Gerador vetorial",
  "admin_vector_models": "Modelos disponíveis",
  "admin_vector_pricing": "Preços e limites",
  "svc_vector-generator_label": "Gerador vetorial inteligente",
  "svc_vector-generator_desc": "Gere gráficos vetoriais SVG prontos para produção a partir de descrições de texto",
  "sp_vector_gen_name": "Gerador vetorial inteligente",
  "sp_vector_gen_desc": "Gere gráficos vetoriais SVG a partir de descrições textuais com tecnologia inteligente.",
  "sp_vector_gen_feat": "Geração texto para vetor|Exportação SVG e PNG|Múltiplos estilos|Editor SVG inline|Upload de referências|Preços por créditos",
  "sp_managed_hosting_name": "Hospedagem gerenciada",
  "sp_managed_hosting_feat": "Monitoramento 24/7|Atualizações automáticas|Gestão SSL|Backups diários|Otimização|Suporte dedicado",
  "sp_enterprise_ad_name": "Publicidade empresarial",
  "sp_enterprise_ad_feat": "Estratégia de campanha|Multi-canal|Testes A/B|Acompanhamento|Gestor dedicado|Relatórios",
  "sp_email_marketing_name": "Configuração de email marketing",
  "sp_email_marketing_feat": "Sequências de email|Design de templates|Automação|Gestão de listas|Analytics|Testes A/B",
  "sp_competitor_analysis_name": "Relatório de análise competitiva",
  "sp_competitor_analysis_feat": "Análise de mercado|Perfil concorrentes|SWOT|Comparação preços|Recomendações|Atualizações",
  "sp_website_audit_name": "Auditoria de site e relatório SEO",
  "sp_website_audit_feat": "Auditoria técnica|Análise SEO|Métricas|Acessibilidade|Scan segurança|Plano de ação",
  "sp_defi_name": "Soluções DeFi",
  "sp_defi_feat": "Contratos inteligentes|Yield farming|Pools de liquidez|Auditoria DeFi|Criação de tokens|Soluções de staking",
  "sp_personal_brand_name": "Marca pessoal",
  "sp_personal_brand_feat": "Estratégia de marca|Presença nas redes sociais|Site pessoal|Planejamento de conteúdo|Fotos profissionais|Redação de bio",
  "sp_ad_gen_name": "Gerador de anúncios",
  "sp_ad_gen_feat": "Textos publicitários|Formatos criativos|Multi-plataforma|Variantes A/B|Segmentação|Dicas de desempenho",
  "sp_priority_name": "Fila prioritária",
  "sp_priority_feat": "Resposta em 4 horas|Canal dedicado|Processamento prioritário|Atualizações de status|Garantia SLA|Suporte estendido",
  "sp_maintenance_name": "Plano de manutenção",
  "sp_maintenance_feat": "Atualizações mensais|Patches de segurança|Monitoramento de desempenho|Correção de bugs|Garantia de uptime|Suporte prioritário",
  "sp_consulting_name": "Sessão de consultoria inteligente",
  "sp_consulting_feat": "Consultoria especializada|Sessão de estratégia|Assessoria técnica|Plano de implementação|Notas de acompanhamento|Gravação incluída",
  "sp_market_snapshot_name": "Panorama de mercado",
  "sp_market_snapshot_feat": "Panorama do mercado|Tendências-chave|Cenário competitivo|Oportunidades de crescimento|Fatores de risco|Resumo executivo",
  "sp_trend_explainer_name": "Explicador de tendências",
  "sp_trend_explainer_feat": "Análise de tendências|Impacto setorial|Avaliação de oportunidades|Projeção temporal|Passos de ação|Relatório visual",
  "sp_competitor_qa_name": "Perguntas sobre concorrentes",
  "sp_competitor_qa_feat": "Análise de estratégia|Insights de preços|Posicionamento|Comparação|Análise de fraquezas|Mapa de oportunidades",
  "sp_country_entry_name": "Verificação de entrada no mercado",
  "sp_country_entry_feat": "Preparação do mercado|Panorama regulatório|Fatores culturais|Análise competitiva|Estratégia de entrada|Avaliação de riscos",
  "sp_vendor_shortlist_name": "Lista curta de fornecedores",
  "sp_vendor_shortlist_feat": "Pesquisa de fornecedores|Matriz comparativa|Análise de preços|Avaliação de capacidades|Recomendações|Dados de contato",
  "sp_tam_logic_name": "Esboço lógico TAM",
  "sp_tam_logic_feat": "Estimativa TAM|Detalhamento SAM/SOM|Framework lógico|Fontes de dados|Premissas de crescimento|Apresentação visual",
  "sp_positioning_name": "Ângulo de posicionamento",
  "sp_positioning_feat": "Posicionamento de mercado|Segmentação de público|Proposta de valor|Framework de mensagens|Diferenciação|Vantagem competitiva",
  "sp_managed_trading_name": "Trading gerenciado",
  "sp_managed_trading_feat": "Gestão de carteira|Gestão de riscos|Estratégias comprovadas|Relatórios regulares|Gestor dedicado|Análise de mercado",
  "sp_trading_consult_name": "Consultoria de trading",
  "sp_trading_consult_feat": "Sessões individuais|Desenvolvimento de estratégia|Análise de mercado|Avaliação de riscos|Revisão de carteira|Orientação especializada",
  "sp_domains_name": "Mercado LiveDomain",
  "sp_domains_feat": "Domínios premium|Ofertas aftermarket|Avaliação de domínios|Suporte de transferência|Negociação|Gestão de carteira",
  "sp_domain_mgmt_name": "Gestão de domínios",
  "sp_domain_mgmt_feat": "Gestão DNS|Renovação automática|Suporte de transferência|Rastreamento|Certificados SSL|Privacidade Whois",
  "sp_managed_hosting_desc": "Hospedagem totalmente gerenciada com monitoramento, atualizações e suporte dedicado.",
  "sp_enterprise_ad_desc": "Campanhas publicitárias em grande escala com estratégia e gestão dedicadas.",
  "sp_email_marketing_desc": "Sequências de email profissionais, templates e automação de marketing.",
  "sp_competitor_analysis_desc": "Análise aprofundada de mercado e posicionamento competitivo.",
  "sp_website_audit_desc": "Análise completa do site com recomendações operacionais.",
  "sp_managed_trading_desc": "Trading gerenciado por especialistas com estratégias comprovadas e gestão de riscos.",
  "sp_trading_consult_desc": "Sessões individuais de estratégia de trading guiadas por especialistas.",
  "sp_domains_desc": "Aquisição de domínios premium e ofertas no mercado secundário.",
  "sp_domain_mgmt_desc": "Gestão DNS, renovações, transferências e cuidado do portfólio de domínios.",
  "sp_defi_desc": "Contratos inteligentes, yield farming e soluções de pools de liquidez.",
  "sp_personal_brand_desc": "Construa sua presença online e identidade de marca pessoal.",
  "sp_ad_gen_desc": "Gere textos publicitários e criativos de alta conversão instantaneamente.",
  "sp_priority_desc": "Obtenha uma resposta em 4 horas garantida.",
  "sp_maintenance_desc": "Manutenção contínua, atualizações e suporte técnico.",
  "sp_consulting_desc": "Consultoria individual com nossos especialistas em tecnologia inteligente.",
  "sp_market_snapshot_desc": "Visão geral rápida do cenário de mercado e tendências.",
  "sp_trend_explainer_desc": "Entenda as tendências emergentes relevantes para o seu setor.",
  "sp_competitor_qa_desc": "Obtenha respostas sobre as estratégias dos seus concorrentes.",
  "sp_country_entry_desc": "Avalie a prontidão do mercado para expansão internacional.",
  "sp_vendor_shortlist_desc": "Lista curada de fornecedores para suas necessidades específicas.",
  "sp_tam_logic_desc": "Estimativa do mercado total endereçável com análise lógica.",
  "sp_positioning_desc": "Análise de posicionamento de produto + público.",
  "vector_gen_model": "Modelo",
  "vector_gen_quality": "Nível de qualidade",
  "svc_smart-resume_label": "Gerador inteligente de currículo",
  "svc_smart-resume_desc": "Currículos otimizados para ATS pelo nosso sistema inteligente",
  "svc_smart-business-plan_label": "Gerador inteligente de plano de negócios",
  "svc_smart-business-plan_desc": "Plano de negócios completo com finanças e análise de mercado",
  "svc_smart-seo-report_label": "Relatório SEO inteligente",
  "svc_smart-seo-report_desc": "Análise automatizada do site com recomendações acionáveis",
  "svc_smart-brand-kit_label": "Kit inteligente de logo e marca",
  "svc_smart-brand-kit_desc": "Conceito de logo, paleta de cores, tipografia e assets para redes sociais",
  "svc_smart-email-campaign_label": "Campanha de email inteligente",
  "svc_smart-email-campaign_desc": "Email marketing inteligente com sequências otimizadas",
  "svc_smart-social-calendar_label": "Calendário e análise de mídias sociais",
  "svc_smart-social-calendar_desc": "30 dias de postagens geradas com estratégia de engajamento",
  "svc_ad-generator_label": "Gerador de anúncios",
  "svc_ad-generator_desc": "Gere instantaneamente textos publicitários de alta conversão",
  "svc_smart-translation_label": "Serviços de tradução inteligentes",
  "svc_smart-translation_desc": "Tradução profissional de documentos em mais de 50 idiomas",
  "svc_smart-video-script_label": "Escritor inteligente de roteiros de vídeo",
  "svc_smart-video-script_desc": "Roteiros YouTube, TikTok e publicitários otimizados para engajamento",
  "svc_priority-queue_label": "Fila prioritária",
  "svc_priority-queue_desc": "Resposta garantida em 4 horas",
  "svc_maintenance-plan_label": "Plano de manutenção",
  "svc_maintenance-plan_desc": "Manutenção contínua, atualizações e suporte técnico",
  "svc_smart-consulting_label": "Sessão de consultoria inteligente",
  "svc_smart-consulting_desc": "Consultoria individual com nossos especialistas em tecnologia",
  "svc_market-snapshot_label": "Panorama de mercado",
  "svc_market-snapshot_desc": "Visão rápida do seu cenário de mercado",
  "svc_trend-explainer_label": "Explicador de tendências",
  "svc_trend-explainer_desc": "Entenda as tendências emergentes do seu setor",
  "svc_competitor-qa_label": "Perguntas sobre concorrentes",
  "svc_competitor-qa_desc": "Obtenha respostas sobre as estratégias dos seus concorrentes",
  "svc_country-entry-check_label": "Verificação de entrada no mercado",
  "svc_country-entry-check_desc": "Avalie a prontidão do mercado para expansão internacional",
  "svc_should-i-care_label": "Verificação de relevância",
  "svc_should-i-care_desc": "Avalie se uma tendência é importante para o seu negócio",
  "svc_report-matchmaker_label": "Localizador de relatórios",
  "svc_report-matchmaker_desc": "Encontre o relatório de pesquisa certo",
  "svc_which-region-first_label": "Prioridade regional",
  "svc_which-region-first_desc": "Orientação baseada em dados para entrada no mercado regional",
  "svc_vendor-shortlist_label": "Lista curta de fornecedores",
  "svc_vendor-shortlist_desc": "Lista curada de fornecedores para suas necessidades",
  "svc_forecast-explanation_label": "Explicação de previsão",
  "svc_forecast-explanation_desc": "Explicação clara de previsões de mercado",
  "svc_outreach-email-gen_label": "Gerador de emails de prospecção",
  "svc_outreach-email-gen_desc": "Gere emails de prospecção personalizados em escala",
  "svc_executive-summary_label": "Resumo executivo",
  "svc_executive-summary_desc": "Resumos prontos para apresentações",
  "svc_faq-answer-draft_label": "Rascunho de respostas FAQ",
  "svc_faq-answer-draft_desc": "Redija respostas para perguntas frequentes",
  "svc_jtbd-problem_label": "Declaração de problema JTBD",
  "svc_jtbd-problem_desc": "Análise de problema com framework JTBD",
  "svc_tam-logic-sketch_label": "Esboço lógico TAM",
  "svc_tam-logic-sketch_desc": "Estimativa de mercado total com análise lógica",
  "svc_risk-checklist_label": "Lista de verificação de riscos",
  "svc_risk-checklist_desc": "Lista de verificação completa de avaliação de riscos",
  "svc_feature-prioritization_label": "Priorização de funcionalidades",
  "svc_feature-prioritization_desc": "Recomendações de priorização baseadas em dados",
  "svc_next-research-question_label": "Próxima pergunta de pesquisa",
  "svc_next-research-question_desc": "Descubra a próxima pergunta de pesquisa crítica",
  "svc_positioning-angle_label": "Ângulo de posicionamento",
  "svc_positioning-angle_desc": "Análise de posicionamento de produto e público",
  "svc_blog-outline-trend_label": "Esboço de blog a partir de tendência",
  "svc_blog-outline-trend_desc": "Transforme tópicos em alta em esboços de blog estruturados",
  "admin_ai_reports": "Relatórios de serviços IA",
  "admin_project_delivery": "Entrega de projeto",
  "admin_analytics_digest": "[TRANSLATE] Analytics Digest",
  "admin_seo_suggestions": "[TRANSLATE] SEO Optimization",
  "admin_visitor_map": "[TRANSLATE] Visitor Map",
  "admin_competitor_monitor": "[TRANSLATE] Competitor Intelligence",
  "admin_email_workflows": "[TRANSLATE] Email Workflows",
  "admin_collab_editing": "[TRANSLATE] Team Collaboration",
  "admin_status_online": "[TRANSLATE] Online",
  "admin_status_offline": "[TRANSLATE] Offline",
  "admin_status_online_desc": "[TRANSLATE] You are visible as online. Users requesting escalation will be connected to you.",
  "admin_status_offline_desc": "[TRANSLATE] You are offline. Users requesting escalation will see a message to try later.",
  "admin_ai_model": "[TRANSLATE] AI Model",
  "admin_prompts": "[TRANSLATE] Prompts",
  "admin_no_escalations": "[TRANSLATE] No escalations in queue.",
  "blog_edit": "[TRANSLATE] Edit Post",
  "admin_card_visibility": "[TRANSLATE] Card Visibility",
  "sp_managed_hosting": "[TRANSLATE] Managed Hosting",
  "sp_enterprise_ad": "[TRANSLATE] Enterprise Advertising",
  "sp_email_marketing": "[TRANSLATE] Email Marketing Setup",
  "sp_competitor_analysis": "[TRANSLATE] Competitor Analysis Report",
  "sp_website_audit": "[TRANSLATE] Website Audit & SEO Report",
  "sp_managed_trading": "[TRANSLATE] Managed Trading",
  "sp_trading_consult": "[TRANSLATE] Trading Consultations",
  "sp_domains": "[TRANSLATE] LiveDomain Aftermarket",
  "sp_domain_mgmt": "[TRANSLATE] Domain Management",
  "sp_defi": "[TRANSLATE] DeFi Solutions",
  "sp_personal_brand": "[TRANSLATE] Personal Branding",
  "sp_ad_gen": "[TRANSLATE] Ad Generator",
  "sp_priority": "[TRANSLATE] Priority Queue",
  "sp_maintenance": "[TRANSLATE] Maintenance Plan",
  "sp_consulting": "[TRANSLATE] Smart Consulting Session",
  "sp_market_snapshot": "[TRANSLATE] Market Snapshot",
  "sp_trend_explainer": "[TRANSLATE] Trend Explainer",
  "sp_competitor_qa": "[TRANSLATE] Competitor Q&A",
  "sp_country_entry": "[TRANSLATE] Country Entry Check",
  "sp_vendor_shortlist": "[TRANSLATE] Vendor Shortlist Draft",
  "sp_tam_logic": "[TRANSLATE] Quick TAM Logic Sketch",
  "sp_positioning": "[TRANSLATE] Positioning Angle",
  "agency_rista_tooltip": "Falar com RisTA",
  "agency_hero_title_1": "Sites ultrarrápidos que ",
  "agency_hero_title_highlight": "vendem",
  "agency_hero_title_2": " para negócios locais",
  "agency_hero_subtitle_1": "Obtenha um site personalizado que carrega em milissegundos + análises integradas por",
  "agency_hero_subtitle_2": ". Sem páginas lentas, mais leads — lançamento em semanas.",
  "agency_hero_limited": "Vagas limitadas!",
  "agency_hero_cta_pricing": "Ver pacote de €498",
  "agency_hero_cta_audit": "Auditoria gratuita",
  "agency_trust_maintenance": "manutenção depois",
  "agency_trust_efficient": "100% Eficiente",
  "agency_trust_powered": "Alimentado por Sistema Inteligente",
  "agency_speed_title": "Velocidade de carregamento",
  "agency_speed_before": "Antes",
  "agency_speed_after": "Depois",
  "agency_speed_leads": "+35% leads",
  "agency_pain_title_1": "Sites lentos ",
  "agency_pain_title_2": "matam vendas",
  "agency_pain_subtitle": "Cada segundo que seu site leva para carregar, você perde clientes. Aqui está o problema — e como resolvemos.",
  "agency_pain_slow_title": "Carregamento lento = Leads perdidos",
  "agency_pain_slow_desc": "Seu site leva mais de 5 segundos para carregar. Visitantes saem antes de ver sua oferta.",
  "agency_pain_stats_title": "47% saem se >3s",
  "agency_pain_stats_desc": "Pesquisa do Google mostra que quase metade dos visitantes abandona um site móvel que leva mais de 3 segundos para carregar.",
  "agency_pain_stats_source": "Fonte: Google/SOASTA Research, 2017",
  "agency_pain_solution_title": "Nossa tecnologia Speed-First",
  "agency_pain_solution_desc": "Sites personalizados otimizados para carregar em menos de 1 segundo. Cache edge, imagens otimizadas, código minimizado.",
  "agency_pricing_title": "Preços simples e transparentes",
  "agency_pricing_subtitle": "Escolha o plano que se adapta ao seu negócio. Todos os planos incluem nossa tecnologia Speed-First.",
  "agency_pricing_urgency_1": "Apenas ",
  "agency_pricing_urgency_2": " vagas starter restantes este mês",
  "agency_pricing_popular": "MAIS POPULAR",
  "agency_pricing_get_started": "Começar",
  "agency_pricing_guarantee": "Garantia de reembolso de 30 dias",
  "agency_pricing_ideal": "Ideal para:",
  "agency_pricing_starter": "Starter",
  "agency_pricing_onetime": "pagamento único",
  "agency_pricing_starter_ideal": "Empreendedores individuais",
  "agency_pricing_s_1": "Site personalizado ultrarrápido",
  "agency_pricing_s_2": "Domínio + hospedagem por 1 ano",
  "agency_pricing_s_3": "Painel de análises básico",
  "agency_pricing_s_4": "Design responsivo para mobile",
  "agency_pricing_s_5": "Certificado SSL incluído",
  "agency_pricing_performance": "Performance",
  "agency_pricing_perf_ideal": "Lojas em crescimento",
  "agency_pricing_p_1": "Tudo do Starter",
  "agency_pricing_p_2": "E-commerce + recuperação de carrinho",
  "agency_pricing_p_3": "Pacote de otimização SEO",
  "agency_pricing_p_4": "Integração de testes A/B",
  "agency_pricing_p_5": "Suporte prioritário",
  "agency_pricing_premium": "Premium",
  "agency_pricing_prem_ideal": "Negócios em expansão",
  "agency_pricing_pr_1": "Tudo do Performance",
  "agency_pricing_pr_2": "Gestão Google Ads",
  "agency_pricing_pr_3": "Auditorias semanais de desempenho",
  "agency_pricing_pr_4": "Gerente de conta dedicado",
  "agency_pricing_pr_5": "Integrações personalizadas",
  "agency_social_title": "Confiança de negócios locais",
  "agency_social_rista_label": "RisTA AI:",
  "agency_social_rista_quote": "Analiso o comportamento dos visitantes em tempo real para aumentar suas conversões.",
  "agency_social_see_clients": "O que nossos clientes dizem",
  "agency_social_t1_name": "Marko K.",
  "agency_social_t1_role": "CEO, Loja local",
  "agency_social_t1_text": "Dobramos nossos leads no primeiro mês! O site carrega instantaneamente e nossos clientes adoram o novo design.",
  "agency_social_t2_name": "Elena V.",
  "agency_social_t2_role": "Proprietária de restaurante",
  "agency_social_t2_text": "Nossos pedidos online aumentaram 40% após o lançamento. A diferença de velocidade é enorme.",
  "agency_social_t3_name": "Thomas H.",
  "agency_social_t3_role": "Estúdio de fitness",
  "agency_social_t3_text": "Profissional, rápido e realmente cumprem suas promessas. Nossa taxa de reservas subiu 35% em apenas 3 semanas.",
  "agency_social_t4_name": "Ana S.",
  "agency_social_t4_role": "Proprietária de boutique",
  "agency_social_t4_text": "A configuração do e-commerce foi perfeita. A recuperação de carrinho sozinha pagou o plano Performance no primeiro trimestre.",
  "agency_social_metric_1": "Tempo médio de carga",
  "agency_social_metric_2": "Mais leads",
  "agency_social_metric_3": "Satisfação do cliente",
  "agency_services_title": "Tudo que seu negócio precisa",
  "agency_services_subtitle": "Soluções digitais completas para expandir sua presença online.",
  "agency_svc_fast_title": "Sites rápidos",
  "agency_svc_fast_desc": "Sites personalizados carregando em menos de 1 segundo. Mobile-first, otimizados para SEO.",
  "agency_svc_ecom_title": "Lojas E-Commerce",
  "agency_svc_ecom_desc": "Venda online com recuperação de carrinho, processamento de pagamentos e gestão de estoque.",
  "agency_svc_seo_title": "Auditoria SEO & Otimização",
  "agency_svc_seo_desc": "Ranqueie mais alto no Google. SEO técnico, estratégia de conteúdo e relatórios mensais.",
  "agency_svc_ads_title": "Configuração Google Ads",
  "agency_svc_ads_desc": "Obtenha tráfego direcionado rapidamente. Configuração de campanha, otimização e rastreamento de ROI incluídos.",
  "agency_svc_maint_title": "Manutenção & Suporte",
  "agency_svc_maint_desc": "Hospedagem, atualizações de segurança, backups e alterações de conteúdo. A partir de €30/mês.",
  "agency_faq_title": "Perguntas frequentes",
  "agency_faq_q1": "Quão rápido meu site vai carregar?",
  "agency_faq_a1": "Menos de 1 segundo. Otimizamos cada milissegundo — da resposta do servidor ao renderização visual completa.",
  "agency_faq_q2": "O que inclui o pacote Starter de €498?",
  "agency_faq_a2": "Um site ultrarrápido personalizado, domínio e hospedagem por 1 ano, painel de análises, design responsivo e certificado SSL.",
  "agency_faq_q3": "Quanto tempo leva para lançar?",
  "agency_faq_a3": "A maioria dos projetos Starter é lançada em 2-3 semanas. Os planos Performance e Premium levam 4-6 semanas.",
  "agency_faq_q4": "Vocês oferecem manutenção contínua?",
  "agency_faq_a4": "Sim. Após o primeiro ano, a manutenção começa em €30/mês, incluindo hospedagem, atualizações de segurança e alterações menores.",
  "agency_faq_q5": "Posso fazer upgrade do meu plano depois?",
  "agency_faq_a5": "Absolutamente. Você pode fazer upgrade do Starter para Performance ou Premium a qualquer momento. Creditaremos seu investimento inicial.",
  "agency_cta_title_1": "Pronto para escalar ",
  "agency_cta_title_2": "sem limites?",
  "agency_cta_subtitle": "Conte-nos sobre seu negócio e criaremos um plano personalizado. Consultoria gratuita, sem compromisso.",
  "agency_contact_name": "Seu nome",
  "agency_contact_email": "Endereço de email",
  "agency_contact_biz_select": "Selecione tipo de negócio",
  "agency_contact_biz_restaurant": "Restaurante / Alimentação",
  "agency_contact_biz_retail": "Comércio / Loja",
  "agency_contact_biz_services": "Serviços profissionais",
  "agency_contact_biz_fitness": "Fitness / Bem-estar",
  "agency_contact_biz_realestate": "Imóveis",
  "agency_contact_biz_other": "Outro",
  "agency_contact_submit": "Consultoria gratuita",
  "agency_contact_sent_title": "Mensagem enviada!",
  "agency_contact_sent_desc": "Responderemos em 24 horas.",
  "agency_exit_title": "Espere! Auditoria de velocidade grátis?",
  "agency_exit_desc": "Descubra quão mais rápido seu site poderia ser. Relatório detalhado — 100% grátis.",
  "agency_exit_email": "Seu email",
  "agency_exit_submit": "Enviar auditoria",
  "agency_exit_thanks_title": "Obrigado!",
  "agency_exit_thanks_desc": "Enviaremos sua auditoria gratuita em 24 horas.",
  "agency_footer_brand_desc": "Desenvolvido, hospedado e projetado por Infinitybusiness.org",
  "agency_footer_services": "Serviços",
  "agency_footer_fast_web": "Sites rápidos",
  "agency_footer_ecom": "Lojas E-Commerce",
  "agency_footer_seo": "Auditoria SEO",
  "agency_footer_ads": "Configuração Google Ads",
  "agency_footer_maint": "Manutenção",
  "agency_footer_company": "Empresa",
  "agency_footer_about": "Sobre nós",
  "agency_footer_contact": "Contato",
  "agency_footer_privacy": "Política de Privacidade",
  "agency_footer_terms": "Termos e Condições",
  "agency_footer_touch": "Fale conosco",
  "agency_footer_copyright": "© 2026 Infinity Business. Todos os direitos reservados.",
  "agency_footer_dev_by": "Desenvolvido, hospedado e projetado por",
  "agency_footer_newsletter": "Assine a newsletter",
  "agency_footer_subscribe": "Assinar",
  "agency_sticky_pricing": "Ver preços",
  "showroom_page_title": "Showroom",
  "showroom_meta_desc": "Explore nosso portfolio de transformações web. Comparações antes e depois de projetos reais de clientes.",
  "showroom_badge": "Nosso Trabalho",
  "showroom_title_prefix": "Projeto",
  "showroom_title_highlight": "Showroom",
  "showroom_subtitle": "Veja transformações reais. Arraste o controle deslizante para comparar os estados antes e depois dos nossos projetos de clientes.",
  "showroom_search_placeholder": "Pesquisar projetos...",
  "showroom_all_services": "Todos os Serviços",
  "showroom_sort_newest": "Mais recentes",
  "showroom_sort_oldest": "Mais antigos",
  "showroom_sort_name_az": "Nome A-Z",
  "showroom_sort_name_za": "Nome Z-A",
  "showroom_active_filters": "Filtros ativos",
  "showroom_showing": "Mostrando",
  "showroom_project_singular": "projeto",
  "showroom_project_plural": "projetos",
  "showroom_empty": "Ainda não há projetos no showroom.",
  "showroom_no_match": "Nenhum projeto corresponde aos seus filtros.",
  "showroom_features_built": "Funcionalidades Criadas",
  "showroom_visit_live": "Visitar Site ao Vivo"
};
